unit XData.Model.Classes;

{$I XData.inc}

interface

uses
  Classes, SysUtils, Types, StrUtils, TypInfo,
  {$IFDEF ISDELPHI}
  Rtti,
  Bcl.TypInfo.Common,
  {$ELSE}
//  JS,
  {$ENDIF}
  {$IFDEF GENERICS}
  Generics.Defaults,
  Generics.Collections,
  {$ELSE}
  Contnrs,
  {$ENDIF}
  Bcl.Json.Attributes,
  Bcl.Collections.Common,
  Bcl.Rtti.Common;

type
//  TXDataVersion = (v1, v2);
  TXDataEntityType = class;
  TXDataStructuredType = class;
  TXDataInstanceType = class;

  /// <summary>Identifies the kind of a type in the XData model.</summary>
  TXTypeKind = (
    /// <summary>The kind of the type is not defined.</summary>
    xtUndefined,
    /// <summary>A string.</summary>
    xtText,
    /// <summary>A 32-bit integer.</summary>
    xtInt32,
    /// <summary>A 64-bit integer.</summary>
    xtInt64,
    /// <summary>A floating-point number.</summary>
    xtDouble,
    /// <summary>A boolean value.</summary>
    xtBoolean,
    /// <summary>A date and time value.</summary>
    xtDateTime,
    /// <summary>A date value, without the time part.</summary>
    xtDate,
    /// <summary>A time value, without the date part.</summary>
    xtTime,
    /// <summary>A currency value.</summary>
    xtCurrency,
    /// <summary>A GUID.</summary>
    xtGuid,
    /// <summary>A variant value.</summary>
    xtVariant,
    /// <summary>An array of bytes.</summary>
    xtBinary,
    /// <summary>A binary (blob) property of an entity, read and written as a separate stream resource.</summary>
    xtStream,
    /// <summary>A 16-bit integer.</summary>
    xtInt16,
    /// <summary>An unsigned 8-bit integer.</summary>
    xtByte,
    /// <summary>A signed 8-bit integer.</summary>
    xtSByte,
    /// <summary>An entity type.</summary>
    xtEntity,
    /// <summary>A collection of entities.</summary>
    xtEntityCollection,
    /// <summary>An enumerated type.</summary>
    xtEnum,
    /// <summary>A collection of scalar values.</summary>
    xtScalarCollection,
    /// <summary>
    /// Raw content, used by service operations that receive or return a <c>TStream</c>.
    /// </summary>
    xtRaw,
    /// <summary>A plain object type, which is not an Aurelius entity.</summary>
    xtInstance,
    /// <summary>A collection of plain objects.</summary>
    xtInstanceCollection
  );

  TXDataSchema = class;
  TXDataModel = class;
  TXDataTypeConverter = class;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Base class for all the objects that make up an XData model.</summary>
  /// <remarks>
  /// Each model object belongs to the object that contains it, for example a property belongs to its entity
  /// type, and an entity type belongs to its schema. Every model object has a description, and can hold
  /// arbitrary data associated with it.
  /// </remarks>
  TXDataModelObject = class
  strict private
    [JsonIgnore]
    FData: TValue;
    [JsonIgnore]
    FOwnsDataObject: Boolean;
    FDescription: string;
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    [JsonIgnore]
    FParent: TXDataModelObject;
  protected
    property Parent: TXDataModelObject read FParent write FParent;
  public
    destructor Destroy; override;

    /// <summary>Gets or sets arbitrary data associated with the model object.</summary>
    /// <remarks>
    /// XData uses it to keep additional information about the object, such as the Delphi type or method the
    /// object was built from.
    /// </remarks>
    property Data: TValue read FData write FData;
    /// <summary>
    /// Indicates whether the model object owns the object held by <see cref="TXDataModelObject.Data">Data</see>.
    /// </summary>
    /// <remarks>
    /// When <c>True</c>, the object held by <see cref="TXDataModelObject.Data">Data</see> is destroyed together
    /// with the model object.
    /// </remarks>
    property OwnsDataObject: boolean read FOwnsDataObject write FOwnsDataObject;
    /// <summary>Gets or sets the description of the model object.</summary>
    /// <remarks>It is used as the description of the corresponding item in the generated API documentation.</remarks>
    property Description: string read FDescription write FDescription;
  end;

  {$IFDEF GENERICS}
  {$ELSE}
  TXDataOwnedList = class(TObjectList)
  private
    [JsonIgnore]
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    FOwner: TXDataModelObject;
  protected
    {$IFDEF PAS2JS}
    procedure Notify(Ptr: JSValue; Action: TListNotification); override;
    {$ELSE}
    procedure Notify(Ptr: Pointer; Action: TListNotification); override;
    {$ENDIF}
  public
    constructor Create(AOwner: TXDataModelObject); overload;
    constructor Create; reintroduce; overload;
  end;
  {$ENDIF}

  /// <summary>Base class for all the types described in an XData model.</summary>
  /// <remarks>
  /// The model types are the scalar types (primitive and enumerated types), the entity types, the plain
  /// object (instance) types, and the collections of each of them.
  /// </remarks>
  TXDataType = class(TXDataModelObject)
  strict private
    FName: string;
    [JsonIgnore] FUrlConverter: TXDataTypeConverter;
  strict protected
    function GetName: string; virtual;
    function GetIsCollection: boolean; virtual;
    function GetWrappedType: TXDataType; virtual;
    function GetTypeKind: TXTypeKind; virtual;
  public
    /// <summary>Returns the name of the type, qualified by the schema it belongs to.</summary>
    /// <returns>
    /// The name of the type prefixed by the alias of its schema, or by its namespace when the schema has no
    /// alias. For types that do not belong to a schema, it is the same as <see cref="TXDataType.Name">Name</see>.
    /// </returns>
    function QualifiedName: string; virtual;
    /// <summary>Gets or sets the name of the type.</summary>
    /// <remarks>
    /// The name of a collection type is built from the name of its item type, in the format
    /// <c>Collection(ItemTypeName)</c>.
    /// </remarks>
    property Name: string read GetName write FName;
    /// <summary>Indicates whether the type is a collection type.</summary>
    /// <returns><c>True</c> if the type is a collection of items of another type.</returns>
    property IsCollection: boolean read GetIsCollection;
    /// <summary>Gets the type of the items of a collection type.</summary>
    /// <returns>The item type, or <c>nil</c> if the type is not a collection.</returns>
    property WrappedType: TXDataType read GetWrappedType;
    /// <summary>Gets the kind of the type.</summary>
    property TypeKind: TXTypeKind read GetTypeKind;
    /// <summary>
    /// Gets or sets the converter used to convert values of this type to and from literals in URLs.
    /// </summary>
    /// <remarks>It is assigned by the model when the model is prepared.</remarks>
    property UrlConverter: TXDataTypeConverter read FUrlConverter write FUrlConverter;
  end;

  TXDataScalarCollectionType = class;

  /// <summary>Base class for the scalar types, whose values are single values like strings, numbers or enums.</summary>
  TXDataScalarType = class(TXDataType)
  strict private
    [JsonIgnore]
    FCollection: TXDataScalarCollectionType;
  strict protected
    function GetCollection: TXDataScalarType;
  public
    destructor Destroy; override;
    /// <summary>Gets the collection type whose items are of this type.</summary>
    /// <returns>
    /// The collection type, created on first access and owned by this type.
    /// </returns>
    property Collection: TXDataScalarType read GetCollection;
  end;

  /// <summary>Represents one of the name/value pairs that define the valid values of an enumerated type.</summary>
  TXDataEnumMember = class(TXDataModelObject)
  private
    FName: string;
    FValue: integer;
  public
    /// <summary>Gets or sets the name of the enumerated value.</summary>
    property Name: string read FName write FName;
    /// <summary>Gets or sets the ordinal value of the enumerated value.</summary>
    property Value: integer read FValue write FValue;
  end;

  {$IFDEF GENERICS}
  TXDataEnumMemberList = TList<TXDataEnumMember>;
  {$ELSE}
  TXDataEnumMemberList = class(TObjectList)
  private
    function GetItem(Index: Integer): TXDataEnumMember; reintroduce;
  public
    property Items[Index: Integer]: TXDataEnumMember read GetItem; default;
  end;
  {$ENDIF}

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>
  /// Represents an enumerated type, a scalar type whose valid values are defined by a list of name/value pairs.
  /// </summary>
  TXDataEnumType = class(TXDataScalarType)
  strict private
    FMembers: TXDataEnumMemberList;
    function GetSchema: TXDataSchema;
  strict protected
    function GetTypeKind: TXTypeKind; override;
  public
    /// <summary>Returns the name of the enumerated type, qualified by the schema it belongs to.</summary>
    /// <returns>
    /// The name prefixed by the alias of the schema, or by its namespace when the schema has no alias.
    /// </returns>
    function QualifiedName: string; override;
    /// <summary>Gets the schema the enumerated type belongs to.</summary>
    property Schema: TXDataSchema read GetSchema;
  public
    /// <summary>Creates an enumerated type with no members.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Adds a name/value pair to the enumerated type.</summary>
    /// <param name="AName">The name of the enumerated value.</param>
    /// <param name="AValue">The ordinal value of the enumerated value.</param>
    /// <returns>The new member, owned by the enumerated type.</returns>
    function AddMember(const AName: string; AValue: integer): TXDataEnumMember;
    /// <summary>Gets the name/value pairs that define the valid values of the type.</summary>
    /// <returns>The list of members, owned by the enumerated type.</returns>
    property Members: TXDataEnumMemberList read FMembers;
  end;

  {$IFDEF GENERICS}
  TXDataEnumTypeList = TList<TXDataEnumType>;
  {$ELSE}
  TXDataEnumTypeList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataEnumType; reintroduce;
  public
    property Items[Index: Integer]: TXDataEnumType read GetItem; default;
  end;
  {$ENDIF}

  /// <summary>Represents a collection of scalar values of the same type.</summary>
  /// <remarks>
  /// Instances are obtained from the <see cref="TXDataScalarType.Collection">Collection</see> property of the
  /// item type.
  /// </remarks>
  TXDataScalarCollectionType = class(TXDataScalarType)
  strict private
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    [JsonIgnore]
    FItemType: TXDataScalarType;
  strict protected
    function GetIsCollection: boolean; override;
    function GetName: string; override;
    function GetWrappedType: TXDataType; override;
    function GetTypeKind: TXTypeKind; override;
  public
    /// <summary>Returns the qualified name of the collection type.</summary>
    /// <returns>The name in the format <c>Collection(ItemTypeQualifiedName)</c>.</returns>
    function QualifiedName: string; override;
    /// <summary>Gets or sets the type of the items of the collection.</summary>
    property ItemType: TXDataScalarType read FItemType write FItemType;
  end;

  /// <summary>
  /// Defines whether a property or parameter is flagged as required in the generated API documentation.
  /// </summary>
  /// <remarks>
  /// <c>Default</c> lets XData decide based on the definition of the property or parameter. <c>Required</c>
  /// always flags it as required, and <c>NotRequired</c> never does. It only affects the documentation, not the
  /// validation of the requests.
  /// </remarks>
  TDocRequired = (Default, Required, NotRequired);

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Base class for the properties of the structured types in the XData model.</summary>
  /// <remarks>
  /// A property is either a scalar property, holding a single value like a string or a number, or a
  /// structured property (navigation property), which points to another structured type.
  /// </remarks>
  TXDataProperty = class(TXDataModelObject)
  strict private
    FName: string;
    FRequired: Boolean;
    [JsonIgnore]
    FDocRequired: TDocRequired;
    function GetParent: TXDataStructuredType;
  strict protected
    function GetTypeKind: TXTypeKind; virtual; abstract;
    function GetValueType: TXDataType; virtual; abstract;
  public
    /// <summary>Returns <c>True</c> if the property is a scalar property.</summary>
    /// <returns><c>True</c> for scalar properties; <c>False</c> for navigation properties.</returns>
    function IsSimple: Boolean; virtual; abstract;
    /// <summary>Gets the structured type the property belongs to.</summary>
    property Parent: TXDataStructuredType read GetParent;
    /// <summary>Gets the kind of the type of the property value.</summary>
    property TypeKind: TXTypeKind read GetTypeKind;
  public
    /// <summary>Creates a new property.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Returns the name of the property, qualified by the type it belongs to.</summary>
    /// <returns>
    /// The name in the format <c>TypeQualifiedName.PropertyName</c>, or just the property name when the
    /// property does not belong to a type.
    /// </returns>
    function QualifiedName: string;
    /// <summary>Gets or sets the name of the property, as used in JSON and URLs.</summary>
    property Name: string read FName write FName;
    /// <summary>Indicates whether the property requires a value.</summary>
    /// <remarks>
    /// For entity types, it reflects whether the mapped column or association is required in the Aurelius
    /// mapping.
    /// </remarks>
    property Required: Boolean read FRequired write FRequired;
    /// <summary>
    /// Gets or sets whether the property is flagged as required in the generated API documentation.
    /// </summary>
    property DocRequired: TDocRequired read FDocRequired write FDocRequired;
    /// <summary>Gets the type of the property value.</summary>
    property ValueType: TXDataType read GetValueType;
  end;

  {$IFDEF GENERICS}
  TXDataPropertyList = TList<TXDataProperty>;
  {$ELSE}
  TXDataPropertyList = class(TObjectList)
  private
    function GetItem(Index: Integer): TXDataProperty; reintroduce;
  public
    property Items[Index: Integer]: TXDataProperty read GetItem; default;
  end;
  {$ENDIF}

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Base class for the properties that hold a single scalar value, like a string or a number.</summary>
  TXDataScalarProperty = class(TXDataProperty)
  strict private
    [JsonIgnore] FType: TXDataScalarType;
    FLength: Integer;
    FPrecision: Integer;
    FScale: Integer;
    procedure SetType(const Value: TXDataScalarType);
    function GetUrlConverter: TXDataTypeConverter;
  private
    [JsonIgnore] FTypeRef: string;
    function GetTypeRef: string;
  private
    [JsonIgnore]
    FDefaultValue: TValue;
    [JsonIgnore]
    FHasDefaultValue: Boolean;
    procedure SetDefaultValue(const Value: TValue);
  strict protected
    function GetTypeKind: TXTypeKind; override;
    function GetValueType: TXDataType; override;
  public
    /// <summary>Returns <c>True</c>, since scalar properties are always simple properties.</summary>
    /// <returns>Always <c>True</c>.</returns>
    function IsSimple: Boolean; override;
    /// <summary>
    /// Gets or sets the name of the property type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// A name set when the model is read is resolved into
    /// <see cref="TXDataScalarProperty.PropertyType">PropertyType</see> when the model is prepared.
    /// </remarks>
    [JsonProperty('Type')]
    property TypeRef: string read GetTypeRef write FTypeRef;
    /// <summary>
    /// Gets the converter used to convert values of the property to and from literals in URLs.
    /// </summary>
    /// <returns>The URL converter of the property type, or <c>nil</c> if the type is not defined.</returns>
    property UrlConverter: TXDataTypeConverter read GetUrlConverter;
    /// <summary>Gets or sets the type of the property value.</summary>
    property PropertyType: TXDataScalarType read FType write SetType;
    /// <summary>Gets or sets the maximum length of the property value, for string properties.</summary>
    property Length: Integer read FLength write FLength;
    /// <summary>Gets or sets the total number of digits of the property value, for numeric properties.</summary>
    property Precision: Integer read FPrecision write FPrecision;
    /// <summary>
    /// Gets or sets the number of digits after the decimal point of the property value, for numeric
    /// properties.
    /// </summary>
    property Scale: Integer read FScale write FScale;
    /// <summary>Gets or sets the default value of the property.</summary>
    /// <remarks>
    /// Setting a value also sets <see cref="TXDataScalarProperty.HasDefaultValue">HasDefaultValue</see> to
    /// <c>True</c>.
    /// </remarks>
    property DefaultValue: TValue read FDefaultValue write SetDefaultValue;
    /// <summary>
    /// Indicates whether the property has a default value defined in
    /// <see cref="TXDataScalarProperty.DefaultValue">DefaultValue</see>.
    /// </summary>
    property HasDefaultValue: Boolean read FHasDefaultValue write FHasDefaultValue;
  end;

  /// <summary>Represents a simple (scalar) property of an entity type.</summary>
  /// <remarks>
  /// A simple property holds a value of a primitive or enumerated type, like the <c>Name</c> of a
  /// <c>Customer</c> entity. It usually corresponds to a mapped column of the Aurelius entity.
  /// </remarks>
  TXDataSimpleProperty = class(TXDataScalarProperty)
  strict private
    function GetParent: TXDataEntityType;
  private
    procedure Prepare;
  public
    /// <summary>Gets the entity type the property belongs to.</summary>
    property Parent: TXDataEntityType read GetParent;
  end;

  /// <summary>Represents a scalar property of a plain object (instance) type.</summary>
  TXDataInstanceSimpleProperty = class(TXDataScalarProperty)
  strict private
    function GetParent: TXDataInstanceType;
  private
    procedure Prepare;
  public
    /// <summary>Gets the instance type the property belongs to.</summary>
    property Parent: TXDataInstanceType read GetParent;
  end;

  {$IFDEF GENERICS}
  TXDataSimplePropertyList = TList<TXDataSimpleProperty>;
  {$ELSE}
  TXDataSimplePropertyList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataSimpleProperty; reintroduce;
  public
    property Items[Index: Integer]: TXDataSimpleProperty read GetItem; default;
  end;
  {$ENDIF}

  {$IFDEF GENERICS}
  TXDataInstanceScalarPropertyList = TList<TXDataInstanceSimpleProperty>;
  {$ELSE}
  TXDataInstanceScalarPropertyList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataInstanceSimpleProperty; reintroduce;
  public
    property Items[Index: Integer]: TXDataInstanceSimpleProperty read GetItem; default;
  end;
  {$ENDIF}

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>
  /// Base class for the properties whose value is an object or a collection of objects of a structured type.
  /// </summary>
  TXDataStructuredProperty = class(TXDataProperty)
  private
    [JsonIgnore] FTargetRef: string;
    function GetTargetRef: string;
  strict protected
    function GetTarget: TXDataStructuredType; virtual; abstract;
    function GetValueType: TXDataType; override;
  public
    /// <summary>
    /// Gets or sets the name of the target type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// A name set when the model is read is resolved into <see cref="TXDataStructuredProperty.Target">Target</see>
    /// when the model is prepared.
    /// </remarks>
    [JsonProperty('Target')]
    property TargetRef: string read GetTargetRef write FTargetRef;
    /// <summary>Returns <c>False</c>, since structured properties are never simple properties.</summary>
    /// <returns>Always <c>False</c>.</returns>
    function IsSimple: Boolean; override;
    /// <summary>Gets the type of the object, or collection of objects, the property points to.</summary>
    property Target: TXDataStructuredType read GetTarget;
  end;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>
  /// Represents a property of a plain object (instance) type that points to another object or collection of
  /// objects.
  /// </summary>
  TXDataInstanceNavigationProperty = class(TXDataStructuredProperty)
  strict private
    [JsonIgnore] FTarget: TXDataStructuredType;
    function GetParent: TXDataInstanceType;
  private
    procedure Prepare;
  strict protected
    function GetTypeKind: TXTypeKind; override;
    function GetTarget: TXDataStructuredType; override;
  public
    /// <summary>Gets or sets the type the property points to.</summary>
    /// <remarks>It can be an entity type, an instance type, or a collection of either.</remarks>
    property Target: TXDataStructuredType read FTarget write FTarget;
    /// <summary>Gets the instance type the property belongs to.</summary>
    property Parent: TXDataInstanceType read GetParent;
  end;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Represents a navigation property, which relates an entity type to another entity type.</summary>
  /// <remarks>
  /// A navigation property corresponds to an association in the Aurelius mapping. It points either to a single
  /// entity, like the <c>Customer</c> of an <c>Order</c>, or to a collection of entities, like the
  /// <c>Items</c> of an <c>Order</c>.
  /// </remarks>
  TXDataNavigationProperty = class(TXDataStructuredProperty)
  strict private
    [JsonIgnore] FTarget: TXDataEntityType;
    function GetParent: TXDataEntityType;
  private
    procedure Prepare;
  strict protected
    function GetTypeKind: TXTypeKind; override;
    function GetTarget: TXDataStructuredType; override;
  public
    /// <summary>Gets or sets the entity type the property points to.</summary>
    /// <remarks>
    /// For properties that point to a collection of entities, it is an entity collection type, whose
    /// <see cref="TXDataType.IsCollection">IsCollection</see> property is <c>True</c>.
    /// </remarks>
    property Target: TXDataEntityType read FTarget write FTarget;
    /// <summary>Gets the entity type the property belongs to.</summary>
    property Parent: TXDataEntityType read GetParent;
  end;

  {$IFDEF GENERICS}
  TXDataNavigationPropertyList = TList<TXDataNavigationProperty>;
  {$ELSE}
  TXDataNavigationPropertyList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataNavigationProperty; reintroduce;
  public
    property Items[Index: Integer]: TXDataNavigationProperty read GetItem; default;
  end;
  {$ENDIF}

  {$IFDEF GENERICS}
  TXDataInstanceNavigationPropertyList = TList<TXDataInstanceNavigationProperty>;
  {$ELSE}
  TXDataInstanceNavigationPropertyList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataInstanceNavigationProperty; reintroduce;
  public
    property Items[Index: Integer]: TXDataInstanceNavigationProperty read GetItem; default;
  end;
  {$ENDIF}

  /// <summary>Array of simple properties of an entity type.</summary>
  TXDataSimplePropertyArray = array of TXDataSimpleProperty;

  /// <summary>
  /// Base class for the structured types, whose values are objects with scalar and structured properties.
  /// </summary>
  /// <remarks>The structured types are the entity types and the plain object (instance) types.</remarks>
  TXDataStructuredType = class(TXDataType)
  strict private
    function GetSchema: TXDataSchema;
  public
    /// <summary>Returns the number of scalar properties declared in the type.</summary>
    /// <returns>The number of scalar properties.</returns>
    function ScalarPropertyCount: Integer; virtual; abstract;
    /// <summary>Returns a scalar property declared in the type, by its index.</summary>
    /// <param name="Index">
    /// The index of the property, from 0 to
    /// <see cref="TXDataStructuredType.ScalarPropertyCount">ScalarPropertyCount</see> - 1.
    /// </param>
    /// <returns>The scalar property at the specified index.</returns>
    function GetScalarProperty(Index: Integer): TXDataScalarProperty; virtual; abstract;
    /// <summary>Returns the number of structured properties declared in the type.</summary>
    /// <returns>The number of structured properties.</returns>
    function StructuredPropertyCount: Integer; virtual; abstract;
    /// <summary>Returns a structured property declared in the type, by its index.</summary>
    /// <param name="Index">
    /// The index of the property, from 0 to
    /// <see cref="TXDataStructuredType.StructuredPropertyCount">StructuredPropertyCount</see> - 1.
    /// </param>
    /// <returns>The structured property at the specified index.</returns>
    function GetStructuredProperty(Index: Integer): TXDataStructuredProperty; virtual; abstract;
    /// <summary>Looks for a scalar property by its name.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>The scalar property, or <c>nil</c> if no scalar property with that name exists.</returns>
    function FindScalarProperty(const AName: string): TXDataScalarProperty; virtual;
    /// <summary>Looks for a structured property by its name.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>The structured property, or <c>nil</c> if no structured property with that name exists.</returns>
    function FindStructuredProperty(const AName: string): TXDataStructuredProperty; virtual;
    /// <summary>Looks for a scalar or structured property by its name.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>
    /// The property, or <c>nil</c> if no property with that name exists. Scalar properties are searched first.
    /// </returns>
    function FindAnyProperty(const AName: string): TXDataProperty; virtual;
    /// <summary>Gets the schema the type belongs to.</summary>
    property Schema: TXDataSchema read GetSchema;
  end;

  TXDataInstanceCollectionType = class;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Represents a plain object (instance) type, a class that is not an Aurelius entity.</summary>
  /// <remarks>
  /// Instance types describe the classes used as parameters or results of service operations, which are
  /// serialized to and from JSON but are not persisted through automatic CRUD endpoints.
  /// </remarks>
  TXDataInstanceType = class(TXDataStructuredType)
  strict private
    [JsonIgnore]
    FBaseType: TXDataInstanceType;
    FProperties: TXDataInstanceScalarPropertyList;
    FNavigationProperties: TXDataInstanceNavigationPropertyList;
    [JsonIgnore]
    FCollection: TXDataInstanceCollectionType;
  private
    [JsonIgnore]
    FBaseTypeRef: string;
    function GetBaseTypeRef: string;
  public
    /// <summary>
    /// Gets or sets the name of the base type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// A name set when the model is read is resolved into <see cref="TXDataInstanceType.BaseType">BaseType</see>
    /// when the model is prepared.
    /// </remarks>
    [JsonProperty('BaseType')]
    property BaseTypeRef: string read GetBaseTypeRef write FBaseTypeRef;
  private
    procedure Prepare;
  strict protected
    function GetCollection: TXDataInstanceCollectionType;
    function GetTypeKind: TXTypeKind; override;
  public
    /// <summary>Returns the number of scalar properties declared in the type.</summary>
    /// <returns>The number of items in <see cref="TXDataInstanceType.Properties">Properties</see>.</returns>
    function ScalarPropertyCount: Integer; override;
    /// <summary>Returns a scalar property declared in the type, by its index.</summary>
    /// <param name="Index">
    /// The index of the property in <see cref="TXDataInstanceType.Properties">Properties</see>.
    /// </param>
    /// <returns>The scalar property at the specified index.</returns>
    function GetScalarProperty(Index: Integer): TXDataScalarProperty; override;
    /// <summary>Returns the number of structured properties declared in the type.</summary>
    /// <returns>
    /// The number of items in <see cref="TXDataInstanceType.NavigationProperties">NavigationProperties</see>.
    /// </returns>
    function StructuredPropertyCount: Integer; override;
    /// <summary>Returns a structured property declared in the type, by its index.</summary>
    /// <param name="Index">
    /// The index of the property in <see cref="TXDataInstanceType.NavigationProperties">NavigationProperties</see>.
    /// </param>
    /// <returns>The structured property at the specified index.</returns>
    function GetStructuredProperty(Index: Integer): TXDataStructuredProperty; override;
    /// <summary>Returns the name of the instance type, qualified by the schema it belongs to.</summary>
    /// <returns>
    /// The name prefixed by the alias of the schema, or by its namespace when the schema has no alias.
    /// </returns>
    function QualifiedName: string; override;
  public
    /// <summary>Creates an instance type with no properties.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Gets or sets the instance type this type inherits from.</summary>
    /// <returns>The base type, or <c>nil</c> if the type does not inherit from another instance type.</returns>
    property BaseType: TXDataInstanceType read FBaseType write FBaseType;
    /// <summary>Gets the scalar properties declared in the type.</summary>
    /// <returns>The list of scalar properties, owned by the type.</returns>
    property Properties: TXDataInstanceScalarPropertyList read FProperties;
    /// <summary>Gets the properties declared in the type that point to other objects.</summary>
    /// <returns>The list of structured properties, owned by the type.</returns>
    property NavigationProperties: TXDataInstanceNavigationPropertyList read FNavigationProperties;
    /// <summary>Gets the collection type whose items are of this type.</summary>
    /// <returns>The collection type, created on first access and owned by this type.</returns>
    property Collection: TXDataInstanceCollectionType read GetCollection;
  end;

  /// <summary>Represents a collection of plain objects of the same instance type.</summary>
  /// <remarks>
  /// Instances are obtained from the <see cref="TXDataInstanceType.Collection">Collection</see> property of
  /// the item type.
  /// </remarks>
  TXDataInstanceCollectionType = class(TXDataInstanceType)
  strict private
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    [JsonIgnore]
    FItemType: TXDataInstanceType;
  strict protected
    function GetName: string; override;
    function GetIsCollection: Boolean; override;
    function GetWrappedType: TXDataType; override;
    function GetTypeKind: TXTypeKind; override;
  public
    /// <summary>Returns the qualified name of the collection type.</summary>
    /// <returns>The name in the format <c>Collection(ItemTypeQualifiedName)</c>.</returns>
    function QualifiedName: string; override;
    /// <summary>Gets or sets the type of the items of the collection.</summary>
    property ItemType: TXDataInstanceType read FItemType write FItemType;
  end;

  TXDataEntityCollectionType = class;
  TXDataEntitySet = class;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Represents an entity type, the definition of an Aurelius entity class in the XData model.</summary>
  /// <remarks>
  /// An entity type lists the simple and navigation properties of the entity, and which of them make up its
  /// key. It supports inheritance: an entity type can inherit from another entity type. By default, the name
  /// of the entity type is the name of the class without the <c>T</c> prefix, so the class <c>TCustomer</c>
  /// becomes the entity type <c>Customer</c>.
  /// </remarks>
  TXDataEntityType = class(TXDataStructuredType)
  strict private
    [JsonIgnore]
    FKey: TXDataPropertyList;
    [JsonIgnore]
    FBaseType: TXDataEntityType;
    FProperties: TXDataSimplePropertyList;
    FNavigationProperties: TXDataNavigationPropertyList;
    [JsonIgnore]
    FCollection: TXDataEntityCollectionType;
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    [JsonIgnore]
    FDefaultEntitySet: TXDataEntitySet;
  private
    [JsonIgnore]
    FBaseTypeRef: string;
    [JsonIgnore]
    FKeyRef: TStringDynArray;
    function GetBaseTypeRef: string;
    function GetKeyRef: TStringDynArray;
  public
    /// <summary>
    /// Gets or sets the name of the base type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// A name set when the model is read is resolved into <see cref="TXDataEntityType.BaseType">BaseType</see> when
    /// the model is prepared.
    /// </remarks>
    [JsonProperty('BaseType')]
    property BaseTypeRef: string read GetBaseTypeRef write FBaseTypeRef;
    /// <summary>
    /// Gets or sets the names of the key properties, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// Names set when the model is read are resolved into the <see cref="TXDataEntityType.Key">Key</see> list when
    /// the model is prepared.
    /// </remarks>
    [JsonProperty('Key')]
    property KeyRef: TStringDynArray read GetKeyRef write FKeyRef;
  private
    procedure Prepare;
  strict protected
    function GetCollection: TXDataEntityCollectionType;
    function GetTypeKind: TXTypeKind; override;
  private
    property DefaultEntitySet: TXDataEntitySet read FDefaultEntitySet write FDefaultEntitySet;
  public
    /// <summary>Returns the number of simple properties declared in the type.</summary>
    /// <returns>
    /// The number of items in <see cref="TXDataEntityType.Properties">Properties</see>, not including inherited
    /// properties.
    /// </returns>
    function ScalarPropertyCount: Integer; override;
    /// <summary>Returns a simple property declared in the type, by its index.</summary>
    /// <param name="Index">
    /// The index of the property in <see cref="TXDataEntityType.Properties">Properties</see>.
    /// </param>
    /// <returns>The simple property at the specified index.</returns>
    function GetScalarProperty(Index: Integer): TXDataScalarProperty; override;
    /// <summary>Returns the number of navigation properties declared in the type.</summary>
    /// <returns>
    /// The number of items in <see cref="TXDataEntityType.NavigationProperties">NavigationProperties</see>, not
    /// including inherited properties.
    /// </returns>
    function StructuredPropertyCount: Integer; override;
    /// <summary>Returns a navigation property declared in the type, by its index.</summary>
    /// <param name="Index">
    /// The index of the property in <see cref="TXDataEntityType.NavigationProperties">NavigationProperties</see>.
    /// </param>
    /// <returns>The navigation property at the specified index.</returns>
    function GetStructuredProperty(Index: Integer): TXDataStructuredProperty; override;
    /// <summary>Returns the name of the entity type, qualified by the schema it belongs to.</summary>
    /// <returns>
    /// The name prefixed by the alias of the schema, or by its namespace when the schema has no alias.
    /// </returns>
    function QualifiedName: string; override;
    /// <summary>Looks for a simple property by its name, including the inherited properties.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>The property, or <c>nil</c> if neither the type nor its base types have such property.</returns>
    function FindScalarProperty(const AName: string): TXDataScalarProperty; override;
    /// <summary>Looks for a navigation property by its name, including the inherited properties.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>The property, or <c>nil</c> if neither the type nor its base types have such property.</returns>
    function FindStructuredProperty(const AName: string): TXDataStructuredProperty; override;
    /// <summary>Looks for a simple property by its name, including the inherited properties.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>The property, or <c>nil</c> if neither the type nor its base types have such property.</returns>
    function FindProperty(const AName: string): TXDataSimpleProperty;
    /// <summary>Looks for a navigation property by its name, including the inherited properties.</summary>
    /// <param name="AName">The name of the property. The comparison is case-insensitive.</param>
    /// <returns>The property, or <c>nil</c> if neither the type nor its base types have such property.</returns>
    function FindNavigationProperty(const AName: string): TXDataNavigationProperty;
    /// <summary>Checks whether the type is, or inherits from, another entity type.</summary>
    /// <param name="ABase">The entity type to check against.</param>
    /// <returns>
    /// <c>True</c> if the type is <c>ABase</c> itself or has <c>ABase</c> in its chain of base types.
    /// </returns>
    function IsInheritedFrom(ABase: TXDataEntityType): boolean;
    /// <summary>Returns the topmost entity type in the inheritance chain of the type.</summary>
    /// <returns>The root entity type, which is the type itself when it has no base type.</returns>
    function RootType: TXDataEntityType;
    /// <summary>Returns the simple properties that make up the key of the entity.</summary>
    /// <returns>
    /// The simple key properties of the root type, in order. When a key property is an association, it is
    /// replaced by the key properties of the associated entity type.
    /// </returns>
    function KeyScalarProperties: TXDataSimplePropertyArray;
  public
    /// <summary>Creates an entity type with no properties.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Gets or sets the entity type this type inherits from.</summary>
    /// <returns>The base type, or <c>nil</c> if the type does not inherit from another entity type.</returns>
    property BaseType: TXDataEntityType read FBaseType write FBaseType;
    /// <summary>Gets the properties that make up the key (identifier) of the entity.</summary>
    /// <returns>
    /// The list of key properties, which can hold simple and navigation properties. The list does not own
    /// the properties.
    /// </returns>
    property Key: TXDataPropertyList read FKey;
    /// <summary>Gets the simple properties declared in the type.</summary>
    /// <returns>The list of simple properties, owned by the type. Inherited properties are not included.</returns>
    property Properties: TXDataSimplePropertyList read FProperties;
    /// <summary>Gets the navigation properties declared in the type.</summary>
    /// <returns>
    /// The list of navigation properties, owned by the type. Inherited properties are not included.
    /// </returns>
    property NavigationProperties: TXDataNavigationPropertyList read FNavigationProperties;
    /// <summary>Gets the collection type whose items are of this type.</summary>
    /// <returns>The collection type, created on first access and owned by this type.</returns>
    property Collection: TXDataEntityCollectionType read GetCollection;
  end;

  /// <summary>Represents a collection of entities of the same entity type.</summary>
  /// <remarks>
  /// Instances are obtained from the <see cref="TXDataEntityType.Collection">Collection</see> property of the
  /// item type.
  /// </remarks>
  TXDataEntityCollectionType = class(TXDataEntityType)
  strict private
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    [JsonIgnore]
    FItemType: TXDataEntityType;
  strict protected
    function GetName: string; override;
    function GetIsCollection: boolean; override;
    function GetWrappedType: TXDataType; override;
    function GetTypeKind: TXTypeKind; override;
  public
    /// <summary>Returns the qualified name of the collection type.</summary>
    /// <returns>The name in the format <c>Collection(ItemTypeQualifiedName)</c>.</returns>
    function QualifiedName: string; override;
    /// <summary>Gets or sets the type of the items of the collection.</summary>
    property ItemType: TXDataEntityType read FItemType write FItemType;
  end;

  TXDataEntityContainer = class;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Represents an entity set, which publishes the automatic CRUD endpoints of an entity type.</summary>
  /// <remarks>
  /// An entity set is a collection of entities of a given entity type, including entities of the types that
  /// inherit from it. Its name is the first segment of the URL of the CRUD endpoints, as in <c>Customer</c> or
  /// <c>Customer(1)</c>. By default, the entity set has the same name as its entity type.
  /// </remarks>
  TXDataEntitySet = class(TXDataModelObject)
  strict private
    FName: string;
    [JsonIgnore]
    FEntityType: TXDataEntityType;
    [JsonIgnore]
    FTagName: string;
    [JsonIgnore]
    FTagGroup: string;
    function GetContainer: TXDataEntityContainer;
  private
    [JsonIgnore]
    FEntityTypeRef: string;
    function GetEntityTypeRef: string;
  public
    /// <summary>
    /// Gets or sets the name of the entity type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// A name set when the model is read is resolved into <see cref="TXDataEntitySet.EntityType">EntityType</see>
    /// when the model is prepared.
    /// </remarks>
    [JsonProperty('EntityType')]
    property EntityTypeRef: string read GetEntityTypeRef write FEntityTypeRef;
  private
    procedure Prepare;
  public
    /// <summary>Gets or sets the name of the entity set, used in the URL of its endpoints.</summary>
    property Name: string read FName write FName;
    /// <summary>Gets or sets the entity type of the entities in the entity set.</summary>
    property EntityType: TXDataEntityType read FEntityType write FEntityType;
    /// <summary>Gets the entity container the entity set belongs to.</summary>
    property Container: TXDataEntityContainer read GetContainer;
    /// <summary>
    /// Gets or sets the tag under which the endpoints of the entity set are grouped in the generated API
    /// documentation.
    /// </summary>
    /// <remarks>When empty, the name of the entity set is used.</remarks>
    property TagName: string read FTagName write FTagName;
    /// <summary>
    /// Gets or sets the tag group the tag of the entity set belongs to in the generated API documentation.
    /// </summary>
    /// <remarks>
    /// Tag groups are a higher level grouping of tags, displayed by Redoc. When empty, the default tag group
    /// defined in the Swagger options of the server module is used.
    /// </remarks>
    property TagGroup: string read FTagGroup write FTagGroup;
  end;

  {$IFDEF GENERICS}
  TXDataEntitySetList = TList<TXDataEntitySet>;
  {$ELSE}
  TXDataEntitySetList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataEntitySet; reintroduce;
  public
    property Items[Index: Integer]: TXDataEntitySet read GetItem; default;
  end;
  {$ENDIF}

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Groups the entity sets published by a schema.</summary>
  TXDataEntityContainer = class(TXDataModelObject)
  strict private
    FName: string;
    FEntitySets: TXDataEntitySetList;
    function GetSchema: TXDataSchema;
  public
    /// <summary>Gets the schema the entity container belongs to.</summary>
    property Schema: TXDataSchema read GetSchema;
  public
    /// <summary>Creates an entity container with no entity sets.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Looks for an entity set of the container by its name.</summary>
    /// <param name="AName">The name of the entity set. The comparison is case-insensitive.</param>
    /// <returns>The entity set, or <c>nil</c> if the container has no entity set with that name.</returns>
    function FindEntitySet(const AName: string): TXDataEntitySet;
    /// <summary>Gets or sets the name of the entity container.</summary>
    property Name: string read FName write FName;
    /// <summary>Gets the entity sets of the container.</summary>
    /// <returns>The list of entity sets, owned by the container.</returns>
    property EntitySets: TXDataEntitySetList read FEntitySets;
  end;

  {$IFDEF GENERICS}
  TXDataEntityContainerList = TList<TXDataEntityContainer>;
  {$ELSE}
  TXDataEntityContainerList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataEntityContainer; reintroduce;
  public
    property Items[Index: Integer]: TXDataEntityContainer read GetItem; default;
  end;
  {$ENDIF}

  TXDataAction = class;

  /// <summary>Defines from which part of the request the value of a service operation parameter is read.</summary>
  /// <remarks>
  /// <c>FromBody</c> reads the value from the JSON request body. <c>FromURI</c> reads it from the query string
  /// of the URL. <c>FromPath</c> reads it from a segment of the URL path, as defined in the route of the
  /// operation.
  /// </remarks>
  TBindingMode = (FromBody, FromURI {FromQuery}, FromPath);

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Represents a parameter of a service operation.</summary>
  TXDataParamDef = class(TXDataModelObject)
  strict private
    FName: string;
    function GetUrlConverter: TXDataTypeConverter;
  private
    [JsonIgnore]
    FTypeRef: string;
    [JsonIgnore]
    FTypeNameRef: string;
    [JsonIgnore]
    FDocRequired: TDocRequired;
    function GetTypeRef: string;
    function GetTypeNameRef: string;
  public
    /// <summary>
    /// Gets or sets the name of a scalar parameter type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// For backward compatibility with older clients, it only holds a value when the parameter type is a scalar
    /// type that is not a collection. The name of any other type is held by
    /// <see cref="TXDataParamDef.TypeNameRef">TypeNameRef</see>. A name set when the model is read is resolved into
    /// <see cref="TXDataParamDef.ParamType">ParamType</see> when the model is prepared.
    /// </remarks>
    [JsonProperty('Type')]
    property TypeRef: string read GetTypeRef write FTypeRef;
    /// <summary>
    /// Gets or sets the name of a non-scalar parameter type, used when the model is written to or read from
    /// JSON.
    /// </summary>
    /// <remarks>
    /// It only holds a value when <see cref="TXDataParamDef.TypeRef">TypeRef</see> is empty. A name set when the
    /// model is read is resolved into <see cref="TXDataParamDef.ParamType">ParamType</see> when the model is
    /// prepared.
    /// </remarks>
    [JsonProperty('TypeName')]
    property TypeNameRef: string read GetTypeNameRef write FTypeNameRef;
  private
    procedure Prepare;
  private
    [JsonIgnore]
    FType: TXDataType;
    FBindingMode: TBindingMode;
    FOutput: Boolean;
    FInput: Boolean;
    [JsonIgnore]
    FDefaultValue: TValue;
    [JsonIgnore]
    FHasDefaultValue: Boolean;
    procedure SetDefaultValue(const Value: TValue);
    function GetParent: TXDataAction;
  {$IFDEF ISDELPHI}
  strict private
    [JsonIgnore]
    FRttiType: TRttiType;
  public
    /// <summary>Gets or sets the Delphi RTTI type of the parameter.</summary>
    property RttiType: TRttiType read FRttiType write FRttiType;
  {$ENDIF}
  public
    /// <summary>Returns the position of the parameter in the parameter list of its service operation.</summary>
    /// <returns>
    /// The zero-based index of the parameter in the <see cref="TXDataAction.Parameters">Parameters</see> list of
    /// the operation.
    /// </returns>
    function Index: Integer;
    /// <summary>Gets the service operation the parameter belongs to.</summary>
    property Parent: TXDataAction read GetParent;
  public
    /// <summary>
    /// Gets the converter used to convert values of the parameter to and from literals in URLs.
    /// </summary>
    /// <returns>The URL converter of the parameter type, or <c>nil</c> if the type is not defined.</returns>
    property UrlConverter: TXDataTypeConverter read GetUrlConverter;
    /// <summary>Gets or sets the name of the parameter.</summary>
    property Name: string read FName write FName;
    /// <summary>Gets or sets from which part of the request the parameter value is read.</summary>
    property BindingMode: TBindingMode read FBindingMode write FBindingMode;
    /// <summary>Indicates whether the parameter value is sent back to the client in the response.</summary>
    /// <remarks>It is <c>True</c> for parameters declared as <c>var</c> or <c>out</c>.</remarks>
    property Output: Boolean read FOutput write FOutput;
    /// <summary>Indicates whether the parameter value is received from the client in the request.</summary>
    /// <remarks>It is <c>False</c> only for parameters declared as <c>out</c>.</remarks>
    property Input: Boolean read FInput write FInput;
    /// <summary>
    /// Gets or sets the value used for the parameter when the client does not provide it.
    /// </summary>
    /// <remarks>
    /// Setting a value also sets <see cref="TXDataParamDef.HasDefaultValue">HasDefaultValue</see> to <c>True</c>.
    /// </remarks>
    property DefaultValue: TValue read FDefaultValue write SetDefaultValue;
    /// <summary>
    /// Indicates whether the parameter has a default value defined in
    /// <see cref="TXDataParamDef.DefaultValue">DefaultValue</see>.
    /// </summary>
    /// <remarks>A parameter with a default value is optional in the request.</remarks>
    property HasDefaultValue: Boolean read FHasDefaultValue write FHasDefaultValue;
    /// <summary>Gets or sets the type of the parameter.</summary>
    property ParamType: TXDataType read FType write FType;
    /// <summary>
    /// Gets or sets whether the parameter is flagged as required in the generated API documentation.
    /// </summary>
    property DocRequired: TDocRequired read FDocRequired write FDocRequired;
  end;

  {$IFDEF GENERICS}
  TXDataParamDefList = TList<TXDataParamDef>;
  {$ELSE}
  TXDataParamDefList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataParamDef; reintroduce;
  public
    property Items[Index: Integer]: TXDataParamDef read GetItem; default;
  end;
  {$ENDIF}

  EFromURIBindingNotSupported = class(Exception)
  public
    constructor Create(AParam: TXDataParamDef); reintroduce;
  end;

  TXDataController = class;

//  TXDataRouteSegmentType = (Literal, Parameter);

  /// <summary>Represents one segment of the route of a service operation.</summary>
  /// <remarks>
  /// A segment is either a literal text, or a parameter written between braces, as <c>{id}</c> in the route
  /// <c>customers/{id}/orders</c>.
  /// </remarks>
  TXDataRouteSegment = class
  private
    FParamName: string;
    FValue: string;
    FParamIndex: Integer;
    FIsParam: Boolean;
//    FSegmentType: TXDataRouteSegmentType;
  public
    /// <summary>Creates a route segment from its text.</summary>
    /// <param name="AValue">
    /// The text of the segment. A text between braces, like <c>{id}</c>, defines a parameter segment.
    /// </param>
    constructor Create(const AValue: string);
//    property SegmentType: TXDataRouteSegmentType read FSegmentType;
    /// <summary>Gets or sets the text of the segment, as written in the route.</summary>
    property Value: string read FValue write FValue;
    /// <summary>Gets or sets the name of the parameter, for parameter segments.</summary>
    /// <remarks>It is the text between the braces, like <c>id</c> for the segment <c>{id}</c>.</remarks>
    property ParamName: string read FParamName write FParamName;
    /// <summary>
    /// Gets or sets the index, among the path parameters of the service operation, of the parameter bound to
    /// the segment.
    /// </summary>
    property ParamIndex: Integer read FParamIndex write FParamIndex;
    /// <summary>Indicates whether the segment is a parameter.</summary>
    /// <returns><c>True</c> if the segment text is written between braces.</returns>
    property IsParam: Boolean read FIsParam;
  end;

  {$IFDEF GENERICS}
  TXDataRouteSegmentList = TObjectList<TXDataRouteSegment>;
  {$ELSE}
  TXDataRouteSegmentList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataRouteSegment; reintroduce;
  public
    property Items[Index: Integer]: TXDataRouteSegment read GetItem; default;
  end;
  {$ENDIF}

  /// <summary>Holds the segments of a route, used to match request URLs to service operations.</summary>
  TXDataRouteInfo = class
  strict private
    FSegments: TXDataRouteSegmentList;
    FParamCount: Integer;
    FPriority: Integer;
    function GetSegment(Index: Integer): TXDataRouteSegment;
    function GetSegmentCount: Integer;
  public
    /// <summary>Creates an empty route.</summary>
    constructor Create;
    destructor Destroy; override;
    /// <summary>Splits a route into segments and calculates its priority and number of parameters.</summary>
    /// <param name="ARoute">The route, with segments separated by slashes, as in <c>customers/{id}/orders</c>.</param>
    /// <remarks>Empty segments are ignored.</remarks>
    procedure Process(const ARoute: string);
    /// <summary>Gets a segment of the route, by its index.</summary>
    /// <param name="Index">
    /// The index of the segment, from 0 to <see cref="TXDataRouteInfo.SegmentCount">SegmentCount</see> - 1.
    /// </param>
    /// <returns>The route segment at the specified index.</returns>
    property Segments[Index: Integer]: TXDataRouteSegment read GetSegment;
    /// <summary>Gets the number of segments of the route.</summary>
    property SegmentCount: Integer read GetSegmentCount;
    /// <summary>Gets the number of parameter segments in the route.</summary>
    property ParamCount: Integer read FParamCount;
    /// <summary>Gets the priority of the route, used when several routes match the same URL.</summary>
    /// <remarks>
    /// Literal segments raise the priority, and the earlier they appear in the route, the more they count. For
    /// example, the route <c>a/b/{p}</c> has higher priority than <c>a/{p}/c</c>, which in turn has higher
    /// priority than <c>{p}/b/c</c>.
    /// </remarks>
    property Priority: Integer read FPriority;
  end;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Represents a service operation, an endpoint that executes a method of a service contract.</summary>
  /// <remarks>
  /// Each service operation belongs to a controller, which represents the service contract interface, and
  /// usually corresponds to one method of that interface. It defines the route, the HTTP method, the
  /// parameters and the return type of the endpoint.
  /// </remarks>
  TXDataAction = class(TXDataModelObject)
  strict private
    FName: string;
    FParameters: TXDataParamDefList;
    FHttpMethod: string;
    FIsParamStream: Boolean;
    FIsResultStream: Boolean;
    FIsResultCriteria: Boolean;
    FIsResultSingleObject: Boolean;
    FOperationId: string;
    FConsumes: string;
    [JsonIgnore]
    FRemarks: string;
    [JsonIgnore]
    FRouteInfo: TXDataRouteInfo;
    [JsonIgnore]
    FReturnType: TXDataType;
    [JsonIgnore]
    FIsDeprecated: Boolean;
    function ParamCount(Binding: TBindingMode): Integer;
    function GetParam(Binding: TBindingMode; Index: Integer): TXDataParamDef;
  strict private
    [JsonIgnore]
    FReturnTypeRef: string;
    function GetReturnTypeRef: string;
  public
    /// <summary>
    /// Gets or sets the name of the return type, used when the model is written to or read from JSON.
    /// </summary>
    /// <remarks>
    /// A name set when the model is read is resolved into <see cref="TXDataAction.ReturnType">ReturnType</see> when
    /// the model is prepared.
    /// </remarks>
    [JsonProperty('ReturnType')]
    property ReturnTypeRef: string read GetReturnTypeRef write FReturnTypeRef;
  private
    procedure Prepare;
    function GetBodyParam(Index: Integer): TXDataParamDef;
    function GetPathParam(Index: Integer): TXDataParamDef;
    function GetQueryParam(Index: Integer): TXDataParamDef;
  protected
    function GetController: TXDataController;
  public
    /// <summary>Gets the controller (service contract) the service operation belongs to.</summary>
    property Controller: TXDataController read GetController;
    /// <summary>
    /// Gets or sets the detailed description of the service operation in the generated API documentation.
    /// </summary>
    property Remarks: string read FRemarks write FRemarks;
    /// <summary>
    /// Indicates whether the service operation is flagged as deprecated in the generated API documentation.
    /// </summary>
    property IsDeprecated: Boolean read FIsDeprecated write FIsDeprecated;
  public
    /// <summary>Indicates whether the service operation receives the raw request body as a stream.</summary>
    property IsParamStream: Boolean read FIsParamStream write FIsParamStream;
    /// <summary>Indicates whether the service operation returns a <c>TStream</c>.</summary>
    /// <remarks>The content of the stream is sent as the raw response body.</remarks>
    property IsResultStream: Boolean read FIsResultStream write FIsResultStream;
    /// <summary>
    /// Indicates whether the service operation returns an Aurelius
    /// <seeexternal cref="Aurelius.Criteria.Base.TCriteria">TCriteria</seeexternal>.
    /// </summary>
    /// <remarks>The criteria is executed and the resulting list of entities is sent in the response.</remarks>
    property IsResultCriteria: Boolean read FIsResultCriteria write FIsResultCriteria;
    /// <summary>Indicates whether the service operation returns a single object.</summary>
    /// <remarks>
    /// It is <c>True</c> when the operation returns an object and has no <c>var</c> or <c>out</c> parameters.
    /// In this case the object is sent as the response body itself, instead of being wrapped in a
    /// <c>value</c> property.
    /// </remarks>
    property IsResultSingleObject: Boolean read FIsResultSingleObject write FIsResultSingleObject;
    /// <summary>Gets or sets the identifier that uniquely identifies the service operation.</summary>
    /// <remarks>
    /// By default it is the name of the service contract interface and the name of the method, separated by a
    /// dot. It is used as the operation id in the generated API documentation.
    /// </remarks>
    property OperationId: string read FOperationId write FOperationId;
    /// <summary>Gets or sets the content type of the request body accepted by the service operation.</summary>
    /// <remarks>
    /// It is defined by the <seeexternal cref="XData.Service.Common.ConsumesAttribute">Consumes</seeexternal>
    /// attribute. When empty, the operation accepts JSON.
    /// </remarks>
    property Consumes: string read FConsumes write FConsumes;
    /// <summary>Returns <c>True</c> if any parameter of the service operation is sent back in the response.</summary>
    /// <returns><c>True</c> if at least one parameter is declared as <c>var</c> or <c>out</c>.</returns>
    function HasOutputParams: Boolean;
    /// <summary>Returns <c>True</c> if the service operation accepts a form-encoded request body.</summary>
    /// <returns>
    /// <c>True</c> if <see cref="TXDataAction.Consumes">Consumes</see> is <c>application/x-www-form-urlencoded</c>.
    /// </returns>
    function IsFormContent: Boolean;
    /// <summary>Returns <c>True</c> if the service operation accepts a JSON request body.</summary>
    /// <returns>
    /// <c>True</c> if <see cref="TXDataAction.Consumes">Consumes</see> is empty or <c>application/json</c>.
    /// </returns>
    function IsJsonContent: Boolean;
  public
    /// <summary>Creates a service operation with no parameters, which responds to the POST method.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Looks for a parameter by its name.</summary>
    /// <param name="AName">The name of the parameter. The comparison is case-insensitive.</param>
    /// <returns>The parameter, or <c>nil</c> if the operation has no parameter with that name.</returns>
    function FindParameter(const AName: string): TXDataParamDef;
    /// <summary>Returns the position of a parameter in the parameter list, by its name.</summary>
    /// <param name="AName">The name of the parameter. The comparison is case-insensitive.</param>
    /// <returns>
    /// The zero-based index of the parameter in <see cref="TXDataAction.Parameters">Parameters</see>, or -1 if it
    /// is not found.
    /// </returns>
    function IndexOfParameter(const AName: string): Integer;
    /// <summary>Returns the position of a parameter in the parameter list.</summary>
    /// <param name="Param">The parameter to look for.</param>
    /// <returns>
    /// The zero-based index of the parameter in <see cref="TXDataAction.Parameters">Parameters</see>, or -1 if it
    /// is not found.
    /// </returns>
    function IndexOf(Param: TXDataParamDef): Integer;
    /// <summary>Returns the position of the parameter that receives the raw request body.</summary>
    /// <returns>
    /// The index of the first parameter of raw (stream) type, 0 when
    /// <see cref="TXDataAction.IsParamStream">IsParamStream</see> is <c>True</c> and no such parameter exists, or
    /// -1 otherwise.
    /// </returns>
    function ParamStreamIndex: Integer;
    /// <summary>Returns the number of parameters read from the request body.</summary>
    /// <returns>The number of parameters whose binding mode is <c>FromBody</c>.</returns>
    function BodyParamCount: Integer;
    /// <summary>Gets a parameter read from the request body, by its index.</summary>
    /// <param name="Index">
    /// The index of the parameter, from 0 to <see cref="TXDataAction.BodyParamCount">BodyParamCount</see> - 1.
    /// </param>
    /// <returns>The body parameter at the specified index.</returns>
    /// <remarks>Raises <see cref="EIndexOutOfRange">EIndexOutOfRange</see> if the index is not valid.</remarks>
    property BodyParams[Index: Integer]: TXDataParamDef read GetBodyParam;
    /// <summary>Returns the number of parameters read from the URL query string.</summary>
    /// <returns>The number of parameters whose binding mode is <c>FromURI</c>.</returns>
    function QueryParamCount: Integer;
    /// <summary>Gets a parameter read from the URL query string, by its index.</summary>
    /// <param name="Index">
    /// The index of the parameter, from 0 to <see cref="TXDataAction.QueryParamCount">QueryParamCount</see> - 1.
    /// </param>
    /// <returns>The query parameter at the specified index.</returns>
    /// <remarks>Raises <see cref="EIndexOutOfRange">EIndexOutOfRange</see> if the index is not valid.</remarks>
    property QueryParams[Index: Integer]: TXDataParamDef read GetQueryParam;
    /// <summary>Returns the number of path parameters that have no default value.</summary>
    /// <returns>The number of path parameters the URL must provide.</returns>
    function RequiredPathParamCount: Integer;
    /// <summary>Returns the number of parameters read from the URL path.</summary>
    /// <returns>The number of parameters whose binding mode is <c>FromPath</c>.</returns>
    function PathParamCount: Integer;
    /// <summary>Gets a parameter read from the URL path, by its index.</summary>
    /// <param name="Index">
    /// The index of the parameter, from 0 to <see cref="TXDataAction.PathParamCount">PathParamCount</see> - 1.
    /// </param>
    /// <returns>The path parameter at the specified index.</returns>
    /// <remarks>Raises <see cref="EIndexOutOfRange">EIndexOutOfRange</see> if the index is not valid.</remarks>
    property PathParams[Index: Integer]: TXDataParamDef read GetPathParam;
    /// <summary>Gets the full route of the service operation, including the route of its controller.</summary>
    /// <remarks>It is built when the model is prepared.</remarks>
    property RouteInfo: TXDataRouteInfo read FRouteInfo;
  public
    // Despite the name, kept this way for backward compatibility, Name property is actually
    // the relative Route (path) for the action, so besides just "GetCustomers" it can also
    // be "customers/?/items", for example
    /// <summary>Gets or sets the route of the service operation, relative to the route of its controller.</summary>
    /// <remarks>
    /// Despite its name, it holds a route, which can have several segments and parameters, as in
    /// <c>customers/{id}/items</c>. By default it is the name of the method, and it can be changed with the
    /// <seeexternal cref="XData.Service.Common.URIPathSegmentAttribute">Route</seeexternal> attribute.
    /// </remarks>
    property Name: string read FName write FName;
    /// <summary>Gets all the parameters of the service operation.</summary>
    /// <returns>The list of parameters, owned by the service operation.</returns>
    property Parameters: TXDataParamDefList read FParameters;
    /// <summary>Gets or sets the HTTP method the service operation responds to.</summary>
    /// <remarks>Defaults to <c>POST</c>.</remarks>
    property HttpMethod: string read FHttpMethod write FHttpMethod;
    /// <summary>Gets or sets the type of the value returned by the service operation.</summary>
    /// <returns>
    /// The return type, or <c>nil</c> if the operation does not return a value, or returns a stream or a
    /// criteria.
    /// </returns>
    property ReturnType: TXDataType read FReturnType write FReturnType;
  end;

  {$IFDEF GENERICS}
  TXDataActionList = TList<TXDataAction>;
  {$ELSE}
  TXDataActionList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataAction; reintroduce;
  public
    property Items[Index: Integer]: TXDataAction read GetItem; default;
  end;
  {$ENDIF}

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>
  /// Represents a controller, which groups the service operations defined by a service contract interface.
  /// </summary>
  TXDataController = class(TXDataModelObject)
  strict private
    FName: string;
    FActions: TXDataActionList;
    [JsonIgnore]
    FServiceClass: TClass;
    [JsonIgnore]
    FRouteInfo: TXDataRouteInfo;
    [JsonIgnore]
    FTagName: string;
    [JsonIgnore]
    FTagGroup: string;
    function GetSchema: TXDataSchema;
  public
    /// <summary>Gets the schema the controller belongs to.</summary>
    property Schema: TXDataSchema read GetSchema;
  public
    /// <summary>Gets or sets the class that implements the service contract.</summary>
    /// <remarks>
    /// It is assigned by the server module, from the classes marked with the
    /// <seeexternal cref="XData.Service.Common.ServiceImplementationAttribute">ServiceImplementation</seeexternal>
    /// attribute. An instance of the class is created to execute each service operation request.
    /// </remarks>
    property ServiceClass: TClass read FServiceClass write FServiceClass;
    /// <summary>Gets the route of the controller.</summary>
    /// <remarks>It is built from <see cref="TXDataController.Name">Name</see> when the model is prepared.</remarks>
    property RouteInfo2: TXDataRouteInfo read FRouteInfo;
    /// <summary>
    /// Gets or sets the tag under which the service operations of the controller are grouped in the
    /// generated API documentation.
    /// </summary>
    /// <remarks>When empty, the last segment of the controller route is used.</remarks>
    property TagName: string read FTagName write FTagName;
    /// <summary>
    /// Gets or sets the tag group the tag of the controller belongs to in the generated API documentation.
    /// </summary>
    /// <remarks>
    /// Tag groups are a higher level grouping of tags, displayed by Redoc. When empty, the default tag group
    /// defined in the Swagger options of the server module is used.
    /// </remarks>
    property TagGroup: string read FTagGroup write FTagGroup;
  private
    procedure Prepare;
  public
    /// <summary>Creates a controller with no service operations.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>
    /// Gets or sets the route of the controller, which prefixes the routes of its service operations.
    /// </summary>
    /// <remarks>
    /// By default it is the name of the service contract interface without the <c>I</c> prefix, and it can be
    /// changed with the <seeexternal cref="XData.Service.Common.URIPathSegmentAttribute">Route</seeexternal>
    /// attribute.
    /// </remarks>
    property Name: string read FName write FName;
    /// <summary>Gets the service operations of the controller.</summary>
    /// <returns>The list of service operations, owned by the controller.</returns>
    property Actions: TXDataActionList read FActions;
  end;

  {$IFDEF GENERICS}
  TXDataEntityTypeList = TList<TXDataEntityType>;
  {$ELSE}
  TXDataEntityTypeList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataEntityType; reintroduce;
  public
    property Items[Index: Integer]: TXDataEntityType read GetItem; default;
  end;
  {$ENDIF}

  {$IFDEF GENERICS}
  TXDataInstanceTypeList = TList<TXDataInstanceType>;
  {$ELSE}
  TXDataInstanceTypeList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataInstanceType; reintroduce;
  public
    property Items[Index: Integer]: TXDataInstanceType read GetItem; default;
  end;
  {$ENDIF}

  {$IFDEF GENERICS}
  TXDataControllerList = TList<TXDataController>;
  {$ELSE}
  TXDataControllerList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataController; reintroduce;
  public
    property Items[Index: Integer]: TXDataController read GetItem; default;
  end;
  {$ENDIF}

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>
  /// Groups the types, entity containers and controllers of an XData model under a namespace.
  /// </summary>
  /// <remarks>
  /// The model built from the Aurelius mapping has a single schema, with namespace <c>XData.Default</c> and no
  /// alias. The <c>Find</c> methods of the schema receive the local (unqualified) names of the items, and
  /// compare them case-insensitively.
  /// </remarks>
  TXDataSchema = class(TXDataModelObject)
  private
    FNamespace: string;
    FAlias: string;
    function GetModel: TXDataModel;
    function IsCollectionName(const Name: string; var SubType: string): Boolean;
  strict private
    FEntityTypes: TXDataEntityTypeList;
    FEntityContainers: TXDataEntityContainerList;
    FEnumTypes: TXDataEnumTypeList;
    FInstanceTypes: TXDataInstanceTypeList;
    FControllers: TXDataControllerList;
  public
    /// <summary>Creates an empty schema.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Returns the URL converter of a type, creating it when needed.</summary>
    /// <param name="AType">The type to get the converter for.</param>
    /// <returns>
    /// The converter already assigned to the type, the one registered in the model for the type name, or a
    /// new converter for enumerated types. Returns <c>nil</c> if no converter is available.
    /// </returns>
    function FindOrDefineConverter(AType: TXDataType): TXDataTypeConverter;
    /// <summary>Looks for an entity type of the schema by its name.</summary>
    /// <param name="AName">
    /// The name of the entity type. A name in the format <c>Collection(TypeName)</c> returns the collection
    /// type of the named entity type.
    /// </param>
    /// <returns>The entity type, or <c>nil</c> if it is not found.</returns>
    function FindEntityType(const AName: string): TXDataEntityType;
    /// <summary>Looks for an instance type of the schema by its name.</summary>
    /// <param name="AName">
    /// The name of the instance type. A name in the format <c>Collection(TypeName)</c> returns the collection
    /// type of the named instance type.
    /// </param>
    /// <returns>The instance type, or <c>nil</c> if it is not found.</returns>
    function FindInstanceType(const AName: string): TXDataInstanceType;
    /// <summary>Looks for an enumerated type of the schema by its name.</summary>
    /// <param name="AName">The name of the enumerated type.</param>
    /// <returns>The enumerated type, or <c>nil</c> if it is not found.</returns>
    function FindEnumType(const AName: string): TXDataEnumType;
    /// <summary>Looks for a member of any enumerated type of the schema by its name.</summary>
    /// <param name="AName">The name of the enumerated value.</param>
    /// <returns>The first member found with that name, or <c>nil</c> if none is found.</returns>
    function FindEnumMember(const AName: string): TXDataEnumMember;
    /// <summary>Looks for a scalar type by its name.</summary>
    /// <param name="Name">
    /// The name of an enumerated type of the schema or of a primitive type. A name in the format
    /// <c>Collection(TypeName)</c> returns the collection type of the named primitive type.
    /// </param>
    /// <returns>The scalar type, or <c>nil</c> if it is not found.</returns>
    function FindScalarType(const Name: string): TXDataScalarType;
    /// <summary>Looks for a type of any kind by its name.</summary>
    /// <param name="Name">The name of the type.</param>
    /// <returns>
    /// The scalar type, entity type or instance type with that name, searched in that order, or <c>nil</c> if
    /// it is not found.
    /// </returns>
    function FindType(const Name: string): TXDataType;
    /// <summary>Looks for an entity container of the schema by its name.</summary>
    /// <param name="AName">The name of the entity container.</param>
    /// <returns>The entity container, or <c>nil</c> if it is not found.</returns>
    function FindContainer(const AName: string): TXDataEntityContainer;
    /// <summary>Looks for a controller of the schema by its name.</summary>
    /// <param name="AName">The name (route) of the controller.</param>
    /// <returns>The controller, or <c>nil</c> if it is not found.</returns>
    function FindController(const AName: string): TXDataController;
  public
    /// <summary>Gets or sets the namespace of the schema.</summary>
    /// <remarks>
    /// It qualifies the names of the types of the schema when the schema has no
    /// <see cref="TXDataSchema.Alias">Alias</see>.
    /// </remarks>
    property Namespace: string read FNamespace write FNamespace;
    /// <summary>Gets or sets a short alternative to the namespace of the schema.</summary>
    /// <remarks>When not empty, it qualifies the names of the types of the schema instead of the namespace.</remarks>
    property Alias: string read FAlias write FAlias;
    /// <summary>Gets the entity types of the schema.</summary>
    /// <returns>The list of entity types, owned by the schema.</returns>
    property EntityTypes: TXDataEntityTypeList read FEntityTypes;
    /// <summary>Gets the plain object (instance) types of the schema.</summary>
    /// <returns>The list of instance types, owned by the schema.</returns>
    property InstanceTypes: TXDataInstanceTypeList read FInstanceTypes;
    /// <summary>Gets the entity containers of the schema.</summary>
    /// <returns>The list of entity containers, owned by the schema.</returns>
    property EntityContainers: TXDataEntityContainerList read FEntityContainers;
    /// <summary>Gets the enumerated types of the schema.</summary>
    /// <returns>The list of enumerated types, owned by the schema.</returns>
    property EnumTypes: TXDataEnumTypeList read FEnumTypes;
    /// <summary>Gets the controllers of the schema, which hold the service operations.</summary>
    /// <returns>The list of controllers, owned by the schema.</returns>
    property Controllers: TXDataControllerList read FControllers;
    /// <summary>Gets the model the schema belongs to.</summary>
    property Model: TXDataModel read GetModel;
  end;

  {$IFDEF GENERICS}
  TXDataSchemaList = TList<TXDataSchema>;
  {$ELSE}
  TXDataSchemaList = class(TXDataOwnedList)
  private
    function GetItem(Index: Integer): TXDataSchema; reintroduce;
  public
    property Items[Index: Integer]: TXDataSchema read GetItem; default;
  end;
  {$ENDIF}

  TXDataUrlConverters = class
  strict private
    FConverterMap: TStringMap;
  public
    constructor Create; reintroduce;
    destructor Destroy; override;
    function Find(const ATypeName: string): TXDataTypeConverter;
    procedure RegisterConverter(const ATypeName: string; AConverter: TXDataTypeConverter);
  end;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>Base class of the XData model, holding its schemas and the methods to look up its items.</summary>
  /// <remarks>
  /// Methods that receive a qualified name accept the local name prefixed by the namespace or alias of the
  /// schema, as in <c>XData.Default.Customer</c>. The prefix can be omitted for items of a schema with no
  /// alias, which is the case of the model built from the Aurelius mapping.
  /// </remarks>
  TXDataBaseModel = class(TXDataModelObject)
  strict private
    FTitle: string;
    FVersion: string;
    FSchemas: TXDataSchemaList;
  private
    [JsonIgnore]
    FUrlConverters: TXDataUrlConverters;
  strict private
    function GetDefaultEntityContainer: TXDataEntityContainer;
  public
    // This method must be called before using a model. It does the initialization of several
    // parts of the model, like solving references and settings converters
    /// <summary>Initializes the model, making it ready to be used.</summary>
    /// <remarks>
    /// It must be called before the model is used, after all its items are defined. It resolves the
    /// references between items, such as the names of types read from JSON, and assigns the URL converters of
    /// the types.
    /// </remarks>
    procedure Prepare;
  public
    /// <summary>Creates an empty model.</summary>
    constructor Create; reintroduce;
    destructor Destroy; override;
    /// <summary>Looks for a schema by its namespace or alias.</summary>
    /// <param name="APrefix">The namespace or the alias of the schema. The comparison is case-insensitive.</param>
    /// <returns>The schema, or <c>nil</c> if it is not found.</returns>
    function FindSchema(const APrefix: string): TXDataSchema;
    /// <summary>Gets the schemas of the model.</summary>
    /// <returns>The list of schemas, owned by the model.</returns>
    property Schemas: TXDataSchemaList read FSchemas;
    /// <summary>Returns an entity type by its qualified name, raising an exception if it is not found.</summary>
    /// <param name="QualifiedName">The name of the entity type, optionally qualified by its schema.</param>
    /// <returns>The entity type.</returns>
    /// <remarks>
    /// Raises <see cref="EXDataEntityTypeNotFound">EXDataEntityTypeNotFound</see> if the entity type is not found.
    /// </remarks>
    function GetEntityType(const QualifiedName: string): TXDataEntityType;
    /// <summary>Looks for an entity type by its qualified name.</summary>
    /// <param name="QualifiedName">The name of the entity type, optionally qualified by its schema.</param>
    /// <returns>The entity type, or <c>nil</c> if it is not found.</returns>
    function FindEntityType(const QualifiedName: string): TXDataEntityType;
    /// <summary>Returns an entity set by its qualified name, raising an exception if it is not found.</summary>
    /// <param name="QualifiedName">
    /// The name of the entity set, optionally prefixed by the name of its entity container.
    /// </param>
    /// <returns>The entity set.</returns>
    /// <remarks>
    /// Raises <see cref="EXDataEntitySetNotFound">EXDataEntitySetNotFound</see> if the entity set is not found.
    /// </remarks>
    function GetEntitySet(const QualifiedName: string): TXDataEntitySet;
    /// <summary>Looks for an entity set by its qualified name.</summary>
    /// <param name="QualifiedName">
    /// The name of the entity set, optionally prefixed by the name of its entity container. Without the prefix, the
    /// entity set is looked for in the
    /// <see cref="TXDataBaseModel.DefaultEntityContainer">DefaultEntityContainer</see>.
    /// </param>
    /// <returns>The entity set, or <c>nil</c> if it is not found.</returns>
    function FindEntitySet(const QualifiedName: string): TXDataEntitySet;
    /// <summary>Looks for a plain object (instance) type by its qualified name.</summary>
    /// <param name="QualifiedName">The name of the instance type, optionally qualified by its schema.</param>
    /// <returns>The instance type, or <c>nil</c> if it is not found.</returns>
    function FindInstanceType(const QualifiedName: string): TXDataInstanceType;
    /// <summary>Looks for a controller in all the schemas of the model.</summary>
    /// <param name="AName">The name (route) of the controller. The comparison is case-insensitive.</param>
    /// <returns>The first controller found, or <c>nil</c> if it is not found.</returns>
    function FindController(const AName: string): TXDataController;
    /// <summary>Looks for a service operation by its operation id, in all the schemas of the model.</summary>
    /// <param name="AOperationId">The operation id. The comparison is case-insensitive.</param>
    /// <returns>The service operation, or <c>nil</c> if it is not found.</returns>
    function FindActionByOperationId(const AOperationId: string): TXDataAction;
    /// <summary>Returns the entity set that publishes the entities of an entity type.</summary>
    /// <param name="AType">The entity type.</param>
    /// <returns>
    /// The entity set defined with <see cref="TXDataBaseModel.DefineDefaultEntitySet">DefineDefaultEntitySet</see>
    /// or, when none is defined, the first entity set whose entity type is <c>AType</c>. Returns <c>nil</c> if no
    /// such entity set exists.
    /// </returns>
    function DefaultEntitySet(AType: TXDataEntityType): TXDataEntitySet;
    /// <summary>
    /// Defines the entity set returned by <see cref="TXDataBaseModel.DefaultEntitySet">DefaultEntitySet</see> for
    /// an entity type.
    /// </summary>
    /// <param name="AType">The entity type.</param>
    /// <param name="EntitySet">The entity set to use as the default one for the entity type.</param>
    procedure DefineDefaultEntitySet(AType: TXDataEntityType; EntitySet: TXDataEntitySet);
    /// <summary>Gets the default entity container of the model.</summary>
    /// <returns>
    /// The first entity container of the first schema, or <c>nil</c> if the model has no entity container.
    /// </returns>
    property DefaultEntityContainer: TXDataEntityContainer read GetDefaultEntityContainer;
    /// <summary>Gets or sets the title of the model.</summary>
    /// <remarks>Defaults to <c>Server API</c>.</remarks>
    property Title: string read FTitle write FTitle;
    /// <summary>Gets or sets the version of the model.</summary>
    property Version: string read FVersion write FVersion;
  end;

  /// <summary>Function that reads the value of a simple property of an entity.</summary>
  /// <remarks>
  /// <c>Entity</c>: the entity to read the value from. <c>Prop</c>: the simple property to read. The function
  /// returns the value of the property.
  /// </remarks>
  TXDataGetPropValueProc = reference to function(Entity: TValue; Prop: TXDataSimpleProperty): TValue;
  /// <summary>Function that reads the value of a navigation property of an entity.</summary>
  /// <remarks>
  /// <c>Entity</c>: the entity to read the value from. <c>NavProp</c>: the navigation property to read. The
  /// function returns the associated entity.
  /// </remarks>
  TXDataGetNavPropValueProc = reference to function(Entity: TValue; NavProp: TXDataNavigationProperty): TValue;

  [JsonInclude(TInclusionMode.NonDefault)]
  /// <summary>
  /// Describes everything an XData server publishes: the entity types and entity sets of the automatic CRUD
  /// endpoints, the service operations, and the types they use.
  /// </summary>
  /// <remarks>
  /// The model is used by the server module to create the endpoints, and to read and write the data received
  /// and sent by the server. Servers usually use the <c>TXDataAureliusModel</c> descendant, which is built from
  /// the Aurelius mapping and the service contracts of the application.
  /// </remarks>
  TXDataModel = class(TXDataBaseModel)
  strict private
    function BuildCanonicalPath(const EntityPath, KeyPath: string; Encoded, EntityKeyAsSegment: Boolean): string;
  strict protected
    ///	<summary>
    ///	  Returns the key predicate of an object instance, to be used in Url.
    ///	</summary>
    ///	<param name="Entity">
    ///	  The object instance for which the key predicate will be generated
    ///	</param>
    ///	<param name="AType">
    ///	  The entity type associated with the object. Just for optimization purposes
    ///	</param>
    ///	<param name="GetPropValue">
    ///	  Reference to a procedure that will read the value of a property
    ///	</param>
    ///	<param name="GetNavPropValue">
    ///	  Reference to a procedure that will read the value of a navigation property
    ///	</param>
    ///	<returns>
    ///	  The key predicate of the object
    ///	</returns>
    ///	<remarks>
    ///	  This function returns a string containing the key predicate of an
    ///	  object instance. The key predicate is a string representation of the
    ///	  object id, to be used in an Url to identify a web resource relate to
    ///	  the object. For example, in the url
    ///	  <see href="http://localhost/Customers('ABC'" />), the key predicate
    ///	  is 'ABC' (with the quotes).
    ///	</remarks>
    function IdToKeyPredicate(const Entity: TValue; AType: TXDataEntityType;
      GetPropValue: TXDataGetPropValueProc; GetNavPropValue: TXDataGetNavPropValueProc): string; overload;
    /// <summary>
    ///   Returns the key predicate for an entity of the specified class, given a specified value
    /// </summary>
    ///	<remarks>
    ///	  This function returns a string containing the key predicate of a class given the specified id.
    ///	  The key predicate is a string representation of the
    ///	  object id, to be used in an Url to identify a web resource relate to
    ///	  the object. For example, in the url
    ///	  <see href="http://localhost/Customers('ABC'" />), the key predicate
    ///	  is 'ABC' (with the quotes).
    ///   If the class has multiple keys (composite key), TValue must be an array of TValue elements
    ///   with the same number of elements as the entity key properties
    ///	</remarks>
    function IdToKeyPredicate(AType: TXDataEntityType; const Id: TValue): string; overload;
  public
    /// <summary>Builds the canonical URL of an entity from its identifier.</summary>
    /// <param name="EntityType">The entity type of the entity.</param>
    /// <param name="Id">
    /// The identifier of the entity. For entity types with a composite key, it must be an array of <c>TValue</c>
    /// with one value for each key property, in the same order as the key properties.
    /// </param>
    /// <param name="AEncoded">If <c>True</c>, the returned URL is percent-encoded.</param>
    /// <param name="AEntityKeyAsSegment">
    /// If <c>True</c>, the key is written as a separate segment, as in <c>Customer/1</c>. Otherwise it uses the
    /// format <c>Customer(1)</c>.
    /// </param>
    /// <returns>
    /// The canonical URL of the entity, relative to the base URL of the server, without trailing slash. For
    /// example, <c>Customer(15)</c> for a customer whose identifier is 15.
    /// </returns>
    /// <remarks>
    /// Raises <see cref="ECannotBuildCanonicalUrl">ECannotBuildCanonicalUrl</see> if no entity set publishes the
    /// entity type, and
    /// <see cref="ECannotBuildKeyPredicateWrongValueLength">ECannotBuildKeyPredicateWrongValueLength</see> if the
    /// number of values in <c>Id</c> does not match the number of key properties.
    /// </remarks>
    function CanonicalUrlFromId(EntityType: TXDataEntityType; Id: TValue; AEncoded: Boolean = False; AEntityKeyAsSegment: Boolean = False): string; overload;
    /// <summary>Builds the canonical URL of an entity from the entity itself.</summary>
    /// <param name="EntityType">The entity type of the entity.</param>
    /// <param name="Entity">The entity to build the URL for.</param>
    /// <param name="GetPropValue">Function used to read the values of the simple key properties of the entity.</param>
    /// <param name="GetNavPropValue">
    /// Function used to read the associated entities, when a key property is an association.
    /// </param>
    /// <param name="AEncoded">If <c>True</c>, the returned URL is percent-encoded.</param>
    /// <param name="AEntityKeyAsSegment">
    /// If <c>True</c>, the key is written as a separate segment, as in <c>Customer/1</c>. Otherwise it uses the
    /// format <c>Customer(1)</c>.
    /// </param>
    /// <returns>
    /// The canonical URL of the entity, relative to the base URL of the server, without trailing slash.
    /// </returns>
    /// <remarks>
    /// Raises <see cref="ECannotBuildCanonicalUrl">ECannotBuildCanonicalUrl</see> if no entity set publishes the
    /// entity type.
    /// </remarks>
    function CanonicalUrlFromEntity(EntityType: TXDataEntityType; const Entity: TValue; GetPropValue: TXDataGetPropValueProc;
      GetNavPropValue: TXDataGetNavPropValueProc; AEncoded: Boolean = False; AEntityKeyAsSegment: Boolean = False): string;
    /// <summary>Returns the URL of an entity set, relative to the base URL of the server.</summary>
    /// <param name="AEntitySet">The entity set.</param>
    /// <returns>The relative URL of the entity set, which is its name.</returns>
    function EntitySetUrl(const AEntitySet: TXDataEntitySet): string;
    /// <summary>Returns the default schema of the model.</summary>
    /// <returns>The first schema of the model.</returns>
    function DefaultSchema: TXDataSchema;
  end;

  ECannotSetTypeKind = class(Exception)
  public
    constructor Create(Prop: TXDataProperty; Value: TXTypeKind); reintroduce;
  end;

  /// <summary>
  /// Base class for the converters that convert values of a type to and from the literals used in URLs.
  /// </summary>
  /// <remarks>
  /// URL literals are used, for example, in the key of an entity (<c>Customer(15)</c>) and in the query and
  /// path parameters of service operations.
  /// </remarks>
  TXDataTypeConverter = class
  strict private
  strict protected
    function GetXDataType: TXDataScalarType; virtual; abstract;
    function TryValueToUrl(const Value: TValue; out Literal: string): boolean; virtual;
    function TryUrlToValue(const Literal: string; out Value: TValue): boolean; virtual;
  public
    destructor Destroy; override;
    /// <summary>Converts a value to its URL literal.</summary>
    /// <param name="Value">The value to convert. An empty value is converted to <c>null</c>.</param>
    /// <param name="PropName">The name of the property or parameter, used only in error messages.</param>
    /// <returns>The URL literal that represents the value.</returns>
    /// <remarks>
    /// Raises <see cref="EConvertToUrlError">EConvertToUrlError</see> if the value cannot be converted.
    /// </remarks>
    function ValueToUrl(const Value: TValue; const PropName: string = ''): string;
    /// <summary>Converts a URL literal to a value.</summary>
    /// <param name="Literal">The URL literal to convert.</param>
    /// <param name="PropName">The name of the property or parameter, used only in error messages.</param>
    /// <returns>The value represented by the literal.</returns>
    /// <remarks>
    /// Raises <see cref="EConvertFromUrlError">EConvertFromUrlError</see> if the literal cannot be converted.
    /// </remarks>
    function UrlToValue(const Literal: string; const PropName: string = ''): TValue;
    /// <summary>Gets the scalar type handled by the converter.</summary>
    property XDataType: TXDataScalarType read GetXDataType;
  end;

  /// <summary>Exception raised when a value cannot be converted to a URL literal.</summary>
  EConvertToUrlError = class(Exception)
  public
    /// <summary>Creates the exception for a value that could not be converted.</summary>
    /// <param name="PropName">
    /// The name of the property or parameter the value belongs to, included in the message when not empty.
    /// </param>
    /// <param name="Value">The value that could not be converted.</param>
    constructor Create(const PropName: string; Value: TValue); reintroduce;
  end;

  /// <summary>Exception raised when a URL literal cannot be converted to a value.</summary>
  EConvertFromUrlError = class(Exception)
  public
    /// <summary>Creates the exception for a literal that could not be converted.</summary>
    /// <param name="PropName">
    /// The name of the property or parameter the literal belongs to, included in the message when not empty.
    /// </param>
    /// <param name="Literal">The URL literal that could not be converted.</param>
    constructor Create(const PropName, Literal: string); reintroduce;
  end;

  EModelTypeNotFound = class(Exception);

  EModelReferenceNotFound = class(Exception);

  /// <summary>Exception raised when an entity type is not found in the model.</summary>
  EXDataEntityTypeNotFound = class(Exception)
  public
    /// <summary>Creates the exception for an entity type that was not found.</summary>
    /// <param name="AName">The name of the entity type that was looked for.</param>
    constructor Create(const AName: string); reintroduce;
  end;

  /// <summary>Exception raised when an entity set is not found in the model.</summary>
  EXDataEntitySetNotFound = class(Exception)
  public
    /// <summary>Creates the exception for an entity set that was not found.</summary>
    /// <param name="AName">The name of the entity set that was looked for.</param>
    constructor Create(const AName: string); reintroduce;
  end;

  /// <summary>
  /// Exception raised when the number of identifier values does not match the number of key properties of an
  /// entity type.
  /// </summary>
  ECannotBuildKeyPredicateWrongValueLength = class(Exception)
  public
    /// <summary>Creates the exception for an entity type.</summary>
    /// <param name="AType">The entity type whose key could not be built.</param>
    constructor Create(AType: TXDataEntityType); reintroduce;
  end;

  /// <summary>
  /// Exception raised when the canonical URL of an entity cannot be built, because no entity set publishes its
  /// entity type.
  /// </summary>
  ECannotBuildCanonicalUrl = class(Exception)
  public
    /// <summary>Creates the exception for an entity type.</summary>
    /// <param name="AType">The entity type whose canonical URL could not be built.</param>
    constructor Create(AType: TXDataEntityType); reintroduce;
  end;

  EUrlConverterNotFound = class(Exception)
  public
    constructor Create(AType: TXDataType); reintroduce;
  end;

  /// <summary>Exception raised when an index used to access a list of the model is not valid.</summary>
  EIndexOutOfRange = class(Exception)
  end;

  EXDataInvalidRouteParam = class(Exception)
  public
    constructor Create(Action: TXDataAction; const ParamName: string);
  end;

implementation

uses
  Bcl.Utils,
  XData.Model.Types,
  XData.Types.Converters,
  XData.Utils;

procedure ErrorOutOfRange;
begin
  raise EIndexOutOfRange.Create('Index out of range');
end;

{ TXDataTypeConverter }

function TXDataTypeConverter.UrlToValue(const Literal: string; const PropName: string = ''): TValue;
begin
  if not TryUrlToValue(Literal, Result) then
    raise EConvertFromUrlError.Create(PropName, Literal);
end;

destructor TXDataTypeConverter.Destroy;
begin
  inherited;
end;

function TXDataTypeConverter.TryUrlToValue(const Literal: string; out Value: TValue): boolean;
begin
  Result := False;
end;

function TXDataTypeConverter.TryValueToUrl(const Value: TValue; out Literal: string): boolean;
begin
  Result := false;
end;

function TXDataTypeConverter.ValueToUrl(const Value: TValue; const PropName: string = ''): string;
begin
  {$IFDEF ISDELPHI}
  if Value.IsEmpty then
    Exit('null')
  else
  {$ELSE}
  if Value = nil then
    Exit('null')
  else
  {$ENDIF}
  begin
    if not TryValueToUrl(Value, Result) then
      raise EConvertToUrlError.Create(PropName, Value);
  end;
end;

{ EConvertToUrlError }

constructor EConvertToUrlError.Create(const PropName: string; Value: TValue);
begin
  if PropName <> '' then
    inherited CreateFmt('Cannot serialize value "%s" to Url parameter "%s"', [
      {$IFDEF ISDELPHI}
      Value.ToString
      {$ELSE}
      TValue_ToString(Value)
      {$ENDIF}
      , PropName]
    )
  else
    inherited CreateFmt('Cannot serialize value "%s" to Url',
      {$IFDEF ISDELPHI}
      [Value.ToString]
      {$ELSE}
      [TValue_ToString(Value)]
      {$ENDIF}
    );
end;

{ EConvertFromUrlError }

constructor EConvertFromUrlError.Create(const PropName, Literal: string);
begin
  if PropName <> '' then
    inherited CreateFmt('Cannot deserialize value "%s" from Url parameter "%s"', [Literal, PropName])
  else
    inherited CreateFmt('Cannot deserialize value "%s" from Url', [Literal])
end;

{ TOwnedList }

{$IFDEF GENERICS}
type
  TOwnedList<T: TXDataModelObject; TOwner: TXDataModelObject> = class(TObjectList<T>)
  strict private
    {$IFDEF AUTOREFCOUNT}[Weak]{$ENDIF}
    FOwner: {$IFDEF DELPHIXE6_LVL}TOwner{$ELSE}TObject{$ENDIF};
  protected
    procedure Notify(const Value: T; Action: TCollectionNotification); override;
  public
    constructor Create(AOwner: TOwner);
  end;

constructor TOwnedList<T, TOwner>.Create(AOwner: TOwner);
begin
  inherited Create(true);
  FOwner := AOwner;
end;

procedure TOwnedList<T, TOwner>.Notify(const Value: T;
  Action: TCollectionNotification);
begin
  if Action = cnAdded then
    {$IFDEF DELPHIXE6_LVL}
    Value.Parent := FOwner
    {$ELSE}
    Value.Parent := TXDataModelObject(FOwner)
    {$ENDIF}
  else
    Value.Parent := nil;
  inherited;
end;
{$ENDIF}

{ TXDataSchema }

constructor TXDataSchema.Create;
begin
  inherited;
  {$IFDEF GENERICS}
  FEntityTypes := TOwnedList<TXDataEntityType, TXDataSchema>.Create(Self);
  FInstanceTypes := TOwnedList<TXDataInstanceType, TXDataSchema>.Create(Self);
  FEnumTypes := TOwnedList<TXDataEnumType, TXDataSchema>.Create(Self);
  FEntityContainers := TOwnedList<TXDataEntityContainer, TXDataSchema>.Create(Self);
  FControllers := TOwnedList<TXDataController, TXDataSchema>.Create(Self);
  {$ELSE}
  FEntityTypes := TXDataEntityTypeList.Create(Self);
  FInstanceTypes := TXDataInstanceTypeList.Create(Self);
  FEnumTypes := TXDataEnumTypeList.Create(Self);
  FEntityContainers := TXDataEntityContainerList.Create(Self);
  FControllers := TXDataControllerList.Create(Self);
  {$ENDIF}
end;

destructor TXDataSchema.Destroy;
begin
  FEntityTypes.Free;
  FInstanceTypes.Free;
  FEnumTypes.Free;
  FEntityContainers.Free;
  FControllers.Free;
  inherited;
end;

function TXDataSchema.FindController(const AName: string): TXDataController;
var
  Controller: TXDataController;
  I: Integer;
begin
  for I := 0 to Controllers.Count - 1 do
  begin
    Controller := Controllers[I];
    if SameText(Controller.Name, AName) then
      Exit(Controller);
  end;
  Result := nil;
end;

function TXDataSchema.FindContainer(const AName: string): TXDataEntityContainer;
var
  Container: TXDataEntityContainer;
  I: Integer;
begin
  for I := 0 to EntityContainers.Count - 1 do
  begin
    Container := EntityContainers[I];
    if SameText(Container.Name, AName) then
      Exit(Container);
  end;
  Result := nil;
end;

function TXDataSchema.FindEntityType(const AName: string): TXDataEntityType;
var
  EntityType: TXDataEntityType;
  SubType: string;
  I: Integer;
begin
  // Check if it's a collection type
  if IsCollectionName(AName, SubType) then
  begin
    EntityType := FindEntityType(SubType);
    if EntityType <> nil then
      Result := EntityType.Collection
    else
      Result := nil;
  end
  else
  begin
    for I := 0 to EntityTypes.Count - 1 do
    begin
      EntityType := EntityTypes[I];
      if SameText(EntityType.Name, AName) then
        Exit(EntityType);
    end;

    Result := nil;
  end;
end;

function TXDataSchema.FindEnumMember(const AName: string): TXDataEnumMember;
var
  EnumType: TXDataEnumType;
  EnumMember: TXDataEnumMember;
  I, J: Integer;
begin
  for I := 0 to EnumTypes.Count - 1 do
  begin
    EnumType := EnumTypes[I];
    for J := 0 to EnumType.Members.Count - 1 do
    begin
      EnumMember := EnumType.Members[J];
      if SameText(EnumMember.Name, AName) then
        Exit(EnumMember);
    end;
  end;
  Result := nil;
end;

function TXDataSchema.FindEnumType(const AName: string): TXDataEnumType;
var
  EnumType: TXDataEnumType;
  I: Integer;
//  SubType: string;
begin
  // Check if it's a collection type
//  if IsCollectionName(AName, SubType) then
//  begin
//    EnumType := FindEnumType(SubType);
//    if EnumType <> nil then
//      Result := EnumType.Collection
//    else
//      Result := nil;
//  end
//  else
  begin
    for I := 0 to EnumTypes.Count - 1 do
    begin
      EnumType := EnumTypes[I];
      if SameText(EnumType.Name, AName) then
        Exit(EnumType);
    end;
    Result := nil;
  end;
end;

function TXDataSchema.FindInstanceType(const AName: string): TXDataInstanceType;
var
  InstanceType: TXDataInstanceType;
  SubType: string;
  I: Integer;
begin
  // Check if it's a collection type
  if IsCollectionName(AName, SubType) then
  begin
    InstanceType := FindInstanceType(SubType);
    if InstanceType <> nil then
      Result := InstanceType.Collection
    else
      Result := nil;
  end
  else
  begin
    for I := 0 to InstanceTypes.Count - 1 do
    begin
      InstanceType := InstanceTypes[I];
      if SameText(InstanceType.Name, AName) then
        Exit(InstanceType);
    end;

    Result := nil;
  end;
end;

function TXDataSchema.FindOrDefineConverter(
  AType: TXDataType): TXDataTypeConverter;
begin
  if AType = nil then Exit(nil);
  if AType.UrlConverter <> nil then Exit(AType.UrlConverter);

  Result := Model.FUrlConverters.Find(AType.Name);
  if Result = nil then
  begin
    if AType is TXDataEnumType then
    begin
      Result := TXDataEnumConverter.Create(TXDataEnumType(AType));
      Model.FUrlConverters.RegisterConverter(AType.Name, Result);
    end;
  end;
end;

function TXDataSchema.FindScalarType(const Name: string): TXDataScalarType;
var
  SubType: string;
begin
  Result := FindEnumType(Name);
  if Result = nil then
  begin
    // Check if it's a collection type
    if IsCollectionName(Name, SubType) then
    begin
      Result := TXDataPrimitiveTypes.Instance.Find(SubType);
      if Result <> nil then
        Result := Result.Collection;
    end
    else
      Result := TXDataPrimitiveTypes.Instance.Find(Name);
  end;
end;

function TXDataSchema.FindType(const Name: string): TXDataType;
begin
  Result := FindScalarType(Name);
  if Result = nil then
    Result := FindEntityType(Name);
  if Result = nil then
    Result := FindInstanceType(Name);
end;

function TXDataSchema.GetModel: TXDataModel;
begin
  Result := TXDataModel(inherited Parent);
end;

function TXDataSchema.IsCollectionName(const Name: string; var SubType: string): Boolean;
var
  Wrapper: string;
begin
  Result := TXDataUtils.GetNameAndKey(Name, Wrapper, SubType) and
    (Wrapper = 'Collection');
end;

{ TXDataProperty }

constructor TXDataProperty.Create;
begin
  inherited;
end;

destructor TXDataProperty.Destroy;
begin
  inherited;
end;

function TXDataProperty.GetParent: TXDataStructuredType;
begin
  Result := TXDataStructuredType(inherited Parent);
end;

function TXDataProperty.QualifiedName: string;
begin
  if Parent <> nil then
    Result := Parent.QualifiedName + '.' + Self.Name
  else
    Result := Self.Name;
end;

{ TXDataEntityType }

constructor TXDataEntityType.Create;
begin
  inherited;
  {$IFDEF GENERICS}
  FKey := TList<TXDataProperty>.Create;
  FProperties := TOwnedList<TXDataSimpleProperty, TXDataEntityType>.Create(Self);
  FNavigationProperties := TOwnedList<TXDataNavigationProperty, TXDataEntityType>.Create(Self);
  {$ELSE}
  FKey := TXDataPropertyList.Create(False);
  FProperties := TXDataSimplePropertyList.Create(Self);
  FNavigationProperties := TXDataNavigationPropertyList.Create(Self);
  {$ENDIF}
end;

destructor TXDataEntityType.Destroy;
begin
  FKey.Free;
  FNavigationProperties.Free;
  FProperties.Free;
  FCollection.Free;
  inherited;
end;

function TXDataEntityType.FindNavigationProperty(const AName: string): TXDataNavigationProperty;
begin
  Result := TXDataNavigationProperty(FindStructuredProperty(AName));
end;

function TXDataEntityType.FindProperty(const AName: string): TXDataSimpleProperty;
begin
  Result := TXDataSimpleProperty(FindScalarProperty(AName));
end;

function TXDataEntityType.FindStructuredProperty(const AName: string): TXDataStructuredProperty;
begin
  Result := inherited FindStructuredProperty(AName);
  if (Result = nil) and (BaseType <> nil) then
    Result := BaseType.FindStructuredProperty(AName);
end;

function TXDataEntityType.FindScalarProperty(const AName: string): TXDataScalarProperty;
begin
  Result := inherited FindScalarProperty(AName);
  if (Result = nil) and (BaseType <> nil) then
    Result := BaseType.FindScalarProperty(AName);
end;

function TXDataEntityType.GetBaseTypeRef: string;
begin
  if FBaseType <> nil then
    Result := FBaseType.Name
  else
    Result := '';
end;

function TXDataEntityType.GetCollection: TXDataEntityCollectionType;
begin
  if FCollection = nil then
  begin
    FCollection := TXDataEntityCollectionType.Create;
    FCollection.ItemType := Self;
    FCollection.Parent := Self.Parent;
  end;
  Result := FCollection;
end;

function TXDataEntityType.GetKeyRef: TStringDynArray;
var
  I: Integer;
begin
  SetLength(Result, Key.Count);
  for I := 0 to Key.Count - 1 do
    Result[I] := Key[I].Name;
end;

function TXDataEntityType.GetStructuredProperty(Index: Integer): TXDataStructuredProperty;
begin
  Result := NavigationProperties[Index];
end;

function TXDataEntityType.GetScalarProperty(Index: Integer): TXDataScalarProperty;
begin
  Result := Properties[Index];
end;

function TXDataEntityType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtEntity;
end;

function TXDataEntityType.IsInheritedFrom(ABase: TXDataEntityType): boolean;
begin
  if ABase = Self then
    Result := true
  else
    Result := (BaseType <> nil) and BaseType.IsInheritedFrom(ABase);
end;

function TXDataEntityType.KeyScalarProperties: TXDataSimplePropertyArray;

  procedure FillKeyConverters(AType: TXDataEntityType; var KeyProps: TXDataSimplePropertyArray);
  var
    Key: TXDataProperty;
    I: Integer;
  begin
    AType := AType.RootType;
    for I := 0 to AType.Key.Count - 1 do
    begin
      Key := AType.Key[I];
      if Key.IsSimple then
      begin
        SetLength(KeyProps, Length(KeyProps) + 1);
        KeyProps[Length(KeyProps) - 1] := TXDataSimpleProperty(Key);
      end
      else
        FillKeyConverters(TXDataNavigationProperty(Key).Target, KeyProps);
    end;
  end;

var
  KeyProps: TXDataSimplePropertyArray;
begin
  SetLength(KeyProps, 0);
  FillKeyConverters(Self, KeyProps);
  Result := KeyProps;
end;

function TXDataEntityType.StructuredPropertyCount: Integer;
begin
  Result := NavigationProperties.Count;
end;

function TXDataEntityType.QualifiedName: string;
begin
  Result := Self.Name;
  if Self.Schema <> nil then
  begin
    if Self.Schema.Alias <> '' then
      Result := Self.Schema.Alias + '.' + Self.Name
    else
    if Self.Schema.Namespace <> '' then
      Result := Self.Schema.Namespace + '.' + Self.Name;
  end;
end;

function TXDataEntityType.RootType: TXDataEntityType;
begin
  Result := Self;
  while Result.BaseType <> nil do
    Result := Result.BaseType;
end;

procedure TXDataEntityType.Prepare;
var
  KeyItem: string;
  TempProp: TXDataProperty;
  I: Integer;
begin
  if FBaseTypeRef <> '' then
  begin
    BaseType := Schema.FindEntityType(FBaseTypeRef);
    if BaseType = nil then
      raise EModelReferenceNotFound.CreateFmt('BaseType %s not found for entity type %s', [FBaseTypeRef, Name]);
    FBaseTypeRef := '';
  end;
  if BaseType <> nil then
    BaseType.Prepare;

  if Length(FKeyRef) > 0 then
  begin
    Key.Clear;
    for I := 0 to Length(FKeyRef) - 1 do
    begin
      KeyItem := FKeyRef[I];
      TempProp := FindProperty(KeyItem);
      if TempProp = nil then
        TempProp := FindNavigationProperty(KeyItem);
      if TempProp = nil then
        raise EModelReferenceNotFound.CreateFmt('Key property %s not found on entity type %s', [KeyItem, Name]);
      Key.Add(TempProp);
    end;
    SetLength(FKeyRef, 0);
  end;

  for I := 0 to Properties.Count - 1 do
    Properties[I].Prepare;
  for I := 0 to NavigationProperties.Count - 1 do
    NavigationProperties[I].Prepare;
end;

function TXDataEntityType.ScalarPropertyCount: Integer;
begin
  Result := Properties.Count;
end;

{ TXDataSimpleProperty }

function TXDataScalarProperty.GetTypeKind: TXTypeKind;
begin
  if PropertyType = nil then
    Result := TXTypeKind.xtUndefined
  else
    Result := PropertyType.TypeKind;
end;

function TXDataScalarProperty.GetTypeRef: string;
begin
  if FType <> nil then
    Result := FType.Name
  else
    Result := '';
end;

function TXDataScalarProperty.GetUrlConverter: TXDataTypeConverter;
begin
  if PropertyType <> nil then
    Result := PropertyType.UrlConverter
  else
    Result := nil;
end;

function TXDataScalarProperty.GetValueType: TXDataType;
begin
  Result := PropertyType;
end;

function TXDataScalarProperty.IsSimple: Boolean;
begin
  Result := True;
end;

procedure TXDataScalarProperty.SetDefaultValue(const Value: TValue);
begin
  FDefaultValue := Value;
  FHasDefaultValue := True;
end;

procedure TXDataScalarProperty.SetType(const Value: TXDataScalarType);
begin
  // add a restriction here, property cannot be entity type
  // (but can be complex type so we can't restrict by class)

  // Also, type must be in scope (same namespace as property). I.e, property can be
  // either a scalar type, a collection or a complex type in scope
  FType := Value;
end;

{ TXDataSimpleProperty }

function TXDataSimpleProperty.GetParent: TXDataEntityType;
begin
  Result := TXDataEntityType(inherited Parent);
end;

procedure TXDataSimpleProperty.Prepare;
begin
  // Resolve type reference
  if FTypeRef <> '' then
  begin
    PropertyType := Parent.Schema.FindScalarType(FTypeRef);
    if PropertyType = nil then
      raise EModelReferenceNotFound.CreateFmt('Property type %s not found for property %s.%s',
        [FTypeRef, Parent.Name, Name]);
    FTypeRef := '';
  end;

  // Set converter
  if PropertyType.UrlConverter = nil then
    raise EUrlConverterNotFound.Create(PropertyType);
end;

{ TXDataEntityContainer }

constructor TXDataEntityContainer.Create;
begin
  inherited;
  {$IFDEF GENERICS}
  FEntitySets := TOwnedList<TXDataEntitySet, TXDataEntityContainer>.Create(Self);
  {$ELSE}
  FEntitySets := TXDataEntitySetList.Create(Self);
  {$ENDIF}
end;

destructor TXDataEntityContainer.Destroy;
begin
  FEntitySets.Free;
  inherited;
end;

function TXDataEntityContainer.FindEntitySet(
  const AName: string): TXDataEntitySet;
var
  EntitySet: TXDataEntitySet;
  I: Integer;
begin
  for I := 0 to EntitySets.Count - 1 do
  begin
    EntitySet := EntitySets[I];
    if SameText(EntitySet.Name, AName) then
      Exit(EntitySet);
  end;
  Result := nil;
end;

function TXDataEntityContainer.GetSchema: TXDataSchema;
begin
  Result := TXDataSchema(inherited Parent);
end;

{ TXDataEnumType }

function TXDataEnumType.AddMember(const AName: string; AValue: integer): TXDataEnumMember;
begin
  Result := TXDataEnumMember.Create;
  Members.Add(Result);
  Result.Name := AName;
  Result.Value := AValue;
end;

constructor TXDataEnumType.Create;
begin
  {$IFDEF GENERICS}
  FMembers := TObjectList<TXDataEnumMember>.Create(True);
  {$ELSE}
  FMembers := TXDataEnumMemberList.Create;
  {$ENDIF}
end;

destructor TXDataEnumType.Destroy;
begin
  FMembers.Free;
  inherited;
end;

function TXDataEnumType.GetSchema: TXDataSchema;
begin
  Result := TXDataSchema(inherited Parent);
end;

function TXDataEnumType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtEnum;
end;

function TXDataEnumType.QualifiedName: string;
begin
  Result := Self.Name;
  if Self.Schema <> nil then
  begin
    if Self.Schema.Alias <> '' then
      Result := Self.Schema.Alias + '.' + Self.Name
    else
    if Self.Schema.Namespace <> '' then
      Result := Self.Schema.Namespace + '.' + Self.Name;
  end;
end;

{ TXDataModel }

constructor TXDataBaseModel.Create;
begin
  FTitle := 'Server API';
  FVersion := '3';
  {$IFDEF GENERICS}
  FSchemas := TOwnedList<TXDataSchema, TXDataBaseModel>.Create(Self);
  {$ELSE}
  FSchemas := TXDataSchemaList.Create(Self);
  {$ENDIF}
  FUrlConverters := TXDataUrlConverters.Create;
end;

function TXDataBaseModel.DefaultEntitySet(AType: TXDataEntityType): TXDataEntitySet;
var
  Schema: TXDataSchema;
  EntitySet: TXDataEntitySet;
  Container: TXDataEntityContainer;
  SchemaIndex, ContainerIndex, EntitySetIndex: Integer;
begin
  if AType.DefaultEntitySet <> nil then
    Exit(AType.DefaultEntitySet);

  for SchemaIndex := 0 to Schemas.Count - 1 do
  begin
    Schema := Schemas[SchemaIndex];
    for ContainerIndex := 0 to Schema.EntityContainers.Count - 1 do
    begin
      Container := Schema.EntityContainers[ContainerIndex];
      for EntitySetIndex := 0 to Container.EntitySets.Count - 1 do
      begin
        EntitySet := Container.EntitySets[EntitySetIndex];
        if EntitySet.EntityType = AType then
        begin
          DefineDefaultEntitySet(AType, EntitySet);
          Exit(EntitySet);
        end;
      end;
    end;
  end;
  Result := nil;
end;

procedure TXDataBaseModel.DefineDefaultEntitySet(AType: TXDataEntityType;
  EntitySet: TXDataEntitySet);
begin
  AType.DefaultEntitySet := EntitySet;
end;

destructor TXDataBaseModel.Destroy;
begin
  FSchemas.Free;
  FUrlConverters.Free;
  inherited;
end;

function TXDataBaseModel.FindActionByOperationId(
  const AOperationId: string): TXDataAction;
var
  Schema: TXDataSchema;
  Controller: TXDataController;
  Action: TXDataAction;
  I, J, L: Integer;
begin
  Result := nil;
  for I := 0 to Schemas.Count - 1 do
  begin
    Schema := Schemas[I];
    for J := 0 to Schema.Controllers.Count - 1 do
    begin
      Controller := Schema.Controllers[J];
      for L := 0 to Controller.Actions.Count - 1 do
      begin
        Action := Controller.Actions[L];

        if SameText(Action.OperationId, AOperationId) then
          Exit(Action);
      end;
    end;
  end;
end;

function TXDataBaseModel.FindController(const AName: string): TXDataController;
var
  Schema: TXDataSchema;
  I: Integer;
begin
  Result := nil;
  for I := 0 to Schemas.Count - 1 do
  begin
    Schema := Schemas[I];
    Result := Schema.FindController(AName);
    if Result <> nil then
      break;
  end;
end;

function TXDataBaseModel.FindEntitySet(const QualifiedName: string): TXDataEntitySet;
var
  Prefix, LocalName: string;
  Schema: TXDataSchema;
  Container: TXDataEntityContainer;
  I: Integer;
begin
  Result := nil;
  TXDataUtils.GetQualifiedName(QualifiedName, Prefix, LocalName);
  Container := nil;
  if Prefix = '' then
  begin
    Container := DefaultEntityContainer;
  end else
  begin
    for I := 0 to Schemas.Count - 1 do
    begin
      Schema := Schemas[I];
      Container := Schema.FindContainer(Prefix);
      if Container <> nil then
        break;
    end;
  end;
  if Container <> nil then
    Result := Container.FindEntitySet(LocalName);
end;

function TXDataBaseModel.FindEntityType(
  const QualifiedName: string): TXDataEntityType;
var
  Prefix, LocalName: string;
  Schema: TXDataSchema;
begin
  Result := nil;
  TXDataUtils.GetQualifiedName(QualifiedName, Prefix, LocalName);
  Schema := FindSchema(Prefix);
  if Schema <> nil then
    Result := Schema.FindEntityType(LocalName);
end;

function TXDataBaseModel.FindInstanceType(const QualifiedName: string): TXDataInstanceType;
var
  Prefix, LocalName: string;
  Schema: TXDataSchema;
begin
  Result := nil;
  TXDataUtils.GetQualifiedName(QualifiedName, Prefix, LocalName);
  Schema := FindSchema(Prefix);
  if Schema <> nil then
    Result := Schema.FindInstanceType(LocalName);
end;

function TXDataBaseModel.FindSchema(const APrefix: string): TXDataSchema;
var
  LocalSchema: TXDataSchema;
  I: Integer;
begin
  for I := 0 to Schemas.Count - 1 do
  begin
    LocalSchema := Schemas[I];
    if SameText(APrefix, LocalSchema.Namespace) or SameText(APrefix, LocalSchema.Alias) then
      Exit(LocalSchema);
  end;
  Result := nil;
end;

function TXDataBaseModel.GetDefaultEntityContainer: TXDataEntityContainer;
begin
  if (Schemas.Count > 0) and (Schemas[0].EntityContainers.Count > 0) then
    Result := Schemas[0].EntityContainers[0]
  else
    Result := nil;
end;

function TXDataBaseModel.GetEntitySet(
  const QualifiedName: string): TXDataEntitySet;
begin
  Result := FindEntitySet(QualifiedName);
  if Result = nil then
    raise EXDataEntitySetNotFound.Create(QualifiedName);
end;

function TXDataBaseModel.GetEntityType(
  const QualifiedName: string): TXDataEntityType;
begin
  Result := FindEntityType(QualifiedName);
  if Result = nil then
    raise EXDataEntityTypeNotFound.Create(QualifiedName);
end;

procedure TXDataBaseModel.Prepare;
var
  Schema: TXDataSchema;
  Container: TXDataEntityContainer;
  EntitySet: TXDataEntitySet;
  EntityType: TXDataEntityType;
  InstanceType: TXDataInstanceType;
  SchemaIndex: Integer;
  ContainerIndex: Integer;
  EntitySetIndex: Integer;
  EntityTypeIndex: Integer;
  InstanceTypeIndex: Integer;
  ControllerIndex: Integer;
  Controller: TXDataController;
  ScalarTypeIndex: Integer;
  ScalarType: TXDataScalarType;
begin
  for SchemaIndex := 0 to Schemas.Count - 1 do
  begin
    Schema := Schemas[SchemaIndex];

//    Schema.EntityTypes.Sort(TComparer<TXDataEntityType>.Construct(
//      function(const Left, Right: TXDataEntityType): Integer
//      begin
//        Result := CompareText(Left.Name, Right.Name);
//      end));

    // set the UrlConverter for all types
    for ScalarTypeIndex := 0 to TXDataPrimitiveTypes.Instance.Types.Count - 1 do
    begin
      ScalarType := TXDataPrimitiveTypes.Instance.Types[ScalarTypeIndex];
      ScalarType.UrlConverter := Schema.FindOrDefineConverter(ScalarType);
      ScalarType.Collection.UrlConverter := Schema.FindOrDefineConverter(ScalarType.Collection);
    end;
    for ScalarTypeIndex := 0 to Schema.EnumTypes.Count - 1 do
    begin
      ScalarType := Schema.EnumTypes[ScalarTypeIndex];
      ScalarType.UrlConverter := Schema.FindOrDefineConverter(ScalarType);
    end;
    for EntityTypeIndex := 0 to Schema.EntityTypes.Count - 1 do
    begin
      EntityType := Schema.EntityTypes[EntityTypeIndex];
      EntityType.UrlConverter := Schema.FindOrDefineConverter(EntityType);
      EntityType.Collection.UrlConverter := Schema.FindOrDefineConverter(EntityType.Collection);
    end;
    for InstanceTypeIndex := 0 to Schema.InstanceTypes.Count - 1 do
    begin
      InstanceType := Schema.InstanceTypes[InstanceTypeIndex];
      InstanceType.UrlConverter := Schema.FindOrDefineConverter(InstanceType);
      InstanceType.Collection.UrlConverter := Schema.FindOrDefineConverter(InstanceType.Collection);
    end;

    for ContainerIndex := 0 to Schema.EntityContainers.Count - 1 do
    begin
      Container := Schema.EntityContainers[ContainerIndex];
      for EntitySetIndex := 0 to Container.EntitySets.Count - 1 do
      begin
        EntitySet := Container.EntitySets[EntitySetIndex];
        EntitySet.Prepare;
      end;
    end;

    for EntityTypeIndex := 0 to Schema.EntityTypes.Count - 1 do
    begin
      EntityType := Schema.EntityTypes[EntityTypeIndex];
      EntityType.Prepare;
    end;

    for InstanceTypeIndex := 0 to Schema.InstanceTypes.Count - 1 do
    begin
      InstanceType := Schema.InstanceTypes[InstanceTypeIndex];
      InstanceType.Prepare;
    end;

    for ControllerIndex := 0 to Schema.Controllers.Count - 1 do
    begin
      Controller := Schema.Controllers[ControllerIndex];
      Controller.Prepare;
    end;
  end;
end;

{ TXDataModel }

type
  TValueArray = array of TValue;

function TXDataModel.IdToKeyPredicate(const Entity: TValue; AType: TXDataEntityType;
  GetPropValue: TXDataGetPropValueProc; GetNavPropValue: TXDataGetNavPropValueProc): string;

  procedure FillKeyValues(Entity: TValue; AType: TXDataEntityType; var Values: TValueArray);
  var
    Key: TXDataProperty;
    I: Integer;
  begin
    AType := AType.RootType;
    for I := 0 to AType.Key.Count - 1 do
    begin
      Key := AType.Key[I];
      if Key.IsSimple then
      begin
        SetLength(Values, Length(Values) + 1);
        Values[Length(Values) - 1] := GetPropValue(Entity, TXDataSimpleProperty(Key));
      end
      else
        FillKeyValues(
          GetNavPropValue(Entity, TXDataNavigationProperty(Key)),
          TXDataNavigationProperty(Key).Target,
          Values
        );
    end;
  end;

var
  ValueList: TValueArray;
  SimpleKey: TXDataSimpleProperty;
begin
  AType := AType.RootType;
  if AType.Key.Count = 0 then
    Exit('');

  if (AType.Key.Count = 1) and AType.Key[0].IsSimple then
  begin
    SimpleKey := TXDataSimpleProperty(AType.Key[0]);
    Result := SimpleKey.UrlConverter.ValueToUrl(
      GetPropValue(Entity, SimpleKey),
      SimpleKey.Name
      )
  end
  else
  begin
    SetLength(ValueList, 0);
    FillKeyValues(Entity, AType, ValueList);
    {$IFDEF PAS2JS}
    Result := IdToKeyPredicate(AType, ValueList);
    {$ELSE}
    Result := IdToKeyPredicate(AType, TValue.From<TValueArray>(ValueList));
    {$ENDIF}
  end;
end;

function TXDataModel.BuildCanonicalPath(const EntityPath, KeyPath: string; Encoded,
  EntityKeyAsSegment: Boolean): string;
begin
  if EntityKeyAsSegment then
  begin
    if Encoded then
      Result := Format('%s/%s', [TBclUtils.PercentEncode(EntityPath), TBclUtils.PercentEncode(KeyPath)])
    else
      Result := Format('%s/%s', [EntityPath, KeyPath])
  end
  else
  begin
    Result := Format('%s(%s)', [EntityPath, KeyPath]);
    if Encoded then
      Result := TBclUtils.PercentEncode(Result);
  end;
end;

function TXDataModel.CanonicalUrlFromEntity(EntityType: TXDataEntityType;
  const Entity: TValue; GetPropValue: TXDataGetPropValueProc; GetNavPropValue: TXDataGetNavPropValueProc;
  AEncoded: Boolean = False; AEntityKeyAsSegment: Boolean = False): string;
var
  EntitySet: TXDataEntitySet;
  EntityPath, KeyPath: string;
begin
  EntitySet := DefaultEntitySet(EntityType);
  if EntitySet = nil then
    raise ECannotBuildCanonicalUrl.Create(EntityType);

  EntityPath := EntitySetUrl(EntitySet);
  KeyPath := IdToKeyPredicate(Entity, EntityType, GetPropValue, GetNavPropValue);
  Result := BuildCanonicalPath(EntityPath, KeyPath, AEncoded, AEntityKeyAsSegment);
end;

function TXDataModel.CanonicalUrlFromId(EntityType: TXDataEntityType; Id: TValue; AEncoded: Boolean = False; AEntityKeyAsSegment: Boolean = False): string;
var
  EntitySet: TXDataEntitySet;
  EntityPath, KeyPath: string;
begin
  EntitySet := DefaultEntitySet(EntityType);
  if EntitySet = nil then
    raise ECannotBuildCanonicalUrl.Create(EntityType);
  EntityPath := EntitySetUrl(EntitySet);
  KeyPath := IdToKeyPredicate(EntityType, Id);
  Result := BuildCanonicalPath(EntityPath, KeyPath, AEncoded, AEntityKeyAsSegment);
end;

function TXDataModel.DefaultSchema: TXDataSchema;
begin
  if Schemas.Count >= 0 then
    Result := Schemas[0]
  else
    Result := nil;
end;

function TXDataModel.EntitySetUrl(const AEntitySet: TXDataEntitySet): string;
begin
  // todo: use prefixed, qualified name when model has more than one entity container
  // for now, we will consider there is only one default entity container
  Result := AEntitySet.Name;
end;

function TXDataModel.IdToKeyPredicate(AType: TXDataEntityType;
  const Id: TValue): string;
var
  I: integer;
  Value, CastValue: TValue;
  IsArray: Boolean;
  KeyProps: TXDataSimplePropertyArray;
begin
  AType := AType.RootType;
  if AType.Key.Count = 0 then
    Exit('');
  if (AType.Key.Count = 1) and AType.Key[0].IsSimple then
    Result := TXDataSimpleProperty(AType.Key[0]).UrlConverter.ValueToUrl(Id, AType.Key[0].Name)
  else
  begin
    // complex predicate (composite or using associations)
    KeyProps := AType.KeyScalarProperties;
    IsArray := TValue_IsArray(Id);
    if IsArray and (TValue_GetArrayLength(Id) <> Length(KeyProps)) then
      raise ECannotBuildKeyPredicateWrongValueLength.Create(AType);
    if not IsArray and (Length(KeyProps) <> 1) then
      raise ECannotBuildKeyPredicateWrongValueLength.Create(AType);

    for I := 0 to Length(KeyProps) - 1 do
    begin
      if IsArray then
        Value := TValue_GetArrayElement(Id, I)
      else
        Value := Id;
      {$IFDEF PAS2JS}
      CastValue := Value;
      {$ELSE}
      if Value.TypeInfo = TypeInfo(TValue) then
        CastValue := Value.AsType<TValue>
      else
        CastValue := Value;
      {$ENDIF}

      if Result <> '' then
        Result := Result + ',';
      Result := Result + KeyProps[I].UrlConverter.ValueToUrl(CastValue, KeyProps[I].Name);
    end;
  end;
end;

{ TXDataModelObject }

destructor TXDataModelObject.Destroy;
begin
  {$IFDEF ISDELPHI}
  {$IFNDEF AUTOREFCOUNT}
  if OwnsDataObject and FData.IsObject then
    FData.AsObject.Free;
  {$ENDIF}
  {$ENDIF}
  inherited;
end;

{ TXDataType }

function TXDataType.GetIsCollection: boolean;
begin
  Result := false;
end;

function TXDataType.GetName: string;
begin
  Result := FName;
end;


function TXDataType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtUndefined;
end;

function TXDataType.GetWrappedType: TXDataType;
begin
  Result := nil;
end;

function TXDataType.QualifiedName: string;
begin
  Result := Name;
end;

{ TXDataScalarType }

destructor TXDataScalarType.Destroy;
begin
  FCollection.Free;
  inherited;
end;

function TXDataScalarType.GetCollection: TXDataScalarType;
begin
  if FCollection = nil then
  begin
    FCollection := TXDataScalarCollectionType.Create;
    FCollection.ItemType := Self;
  end;
  Result := FCollection;
end;

{ TDataScalarCollectionType }

function TXDataScalarCollectionType.GetIsCollection: boolean;
begin
  Result := true;
end;

{ TXDataEntityCollectionType }

function TXDataEntityCollectionType.GetIsCollection: boolean;
begin
  Result := true;
end;

function TXDataScalarCollectionType.GetName: string;
begin
  if ItemType <> nil then
    Result := Format('Collection(%s)', [ItemType.Name])
  else
    Result := 'Collection()';
end;

function TXDataScalarCollectionType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtScalarCollection;
end;

function TXDataScalarCollectionType.GetWrappedType: TXDataType;
begin
  Result := ItemType;
end;

function TXDataScalarCollectionType.QualifiedName: string;
begin
  if ItemType <> nil then
    Result := Format('Collection(%s)', [ItemType.QualifiedName])
  else
    Result := 'Collection()';
end;

function TXDataEntityCollectionType.GetName: string;
begin
  if ItemType <> nil then
    Result := Format('Collection(%s)', [ItemType.Name])
  else
    Result := 'Collection()';
end;

function TXDataEntityCollectionType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtEntityCollection;
end;

function TXDataEntityCollectionType.GetWrappedType: TXDataType;
begin
  Result := ItemType;
end;

function TXDataEntityCollectionType.QualifiedName: string;
begin
  if ItemType <> nil then
    Result := Format('Collection(%s)', [ItemType.QualifiedName])
  else
    Result := 'Collection()';
end;

{ TXDataEntitySet }

function TXDataEntitySet.GetContainer: TXDataEntityContainer;
begin
  Result := TXDataEntityContainer(inherited Parent);
end;

function TXDataEntitySet.GetEntityTypeRef: string;
begin
  if EntityType <> nil then
    Result := EntityType.Name
  else
    Result := '';
end;

procedure TXDataEntitySet.Prepare;
begin
  if FEntityTypeRef <> '' then
  begin
    EntityType := Container.Schema.FindEntityType(FEntityTypeRef);
    if EntityType = nil then
      raise EModelReferenceNotFound.CreateFmt('EntityType not found: %s', [FEntityTypeRef]);
    FEntityTypeRef := '';
  end;
end;

{ ECannotSetTypeKind }

constructor ECannotSetTypeKind.Create(Prop: TXDataProperty; Value: TXTypeKind);
begin
  inherited CreateFmt('Cannot set property "%s" type to type kind %s',
    [Prop.QualifiedName, IntToStr(Ord(Value))]);
end;

{ TXDataAction }

function TXDataAction.BodyParamCount: Integer;
begin
  Result := ParamCount(TBindingMode.FromBody);
end;

constructor TXDataAction.Create;
begin
  FHttpMethod := 'POST';
  {$IFDEF GENERICS}
  FParameters := TOwnedList<TXDataParamDef, TXDataAction>.Create(Self);
  {$ELSE}
  FParameters := TXDataParamDefList.Create(Self);
  {$ENDIF}
end;

destructor TXDataAction.Destroy;
begin
  FParameters.Free;
  FRouteInfo.Free;
  inherited;
end;

function TXDataAction.FindParameter(const AName: string): TXDataParamDef;
var
  I: Integer;
begin
  I := IndexOfParameter(AName);
  if I >= 0 then
    Result := Parameters[I]
  else
    Result := nil;
end;

function TXDataAction.HasOutputParams: Boolean;
var
  ParamDef: TXDataParamDef;
  I: Integer;
begin
  for I := 0 to Parameters.Count - 1 do
  begin
    ParamDef := Parameters[I];
    if ParamDef.Output then
      Exit(True);
  end;
  Result := False;
end;

function TXDataAction.IndexOf(Param: TXDataParamDef): Integer;
begin
  Result := FParameters.IndexOf(Param);
end;

function TXDataAction.IndexOfParameter(const AName: string): Integer;
var
  I: Integer;
begin
  for I := 0 to Parameters.Count - 1 do
    if SameText(Parameters[I].Name, AName) then
      Exit(I);
  Result := -1;
end;

function TXDataAction.IsFormContent: Boolean;
begin
  Result := SameText(Consumes, 'application/x-www-form-urlencoded');
end;

function TXDataAction.IsJsonContent: Boolean;
begin
  Result := (Consumes = '') or SameText(Consumes, 'application/json');
end;

function TXDataAction.ParamCount(Binding: TBindingMode): Integer;
var
  I: Integer;
begin
  Result := 0;
  for I := 0 to Parameters.Count - 1 do
    if Parameters[I].BindingMode = Binding then
      Inc(Result);
end;

function TXDataAction.PathParamCount: Integer;
begin
  Result := ParamCount(TBindingMode.FromPath);
end;

procedure TXDataAction.Prepare;
var
  ParamDefIndex: Integer;
  ParamDef: TXDataParamDef;
  Segment: TXDataRouteSegment;
  I: Integer;
begin
  for ParamDefIndex := 0 to Parameters.Count - 1 do
  begin
    ParamDef := Parameters[ParamDefIndex];
    ParamDef.Prepare;
  end;

  // Solve return type reference, if any
  if FReturnTypeRef <> '' then
  begin
    ReturnType := Controller.Schema.FindType(FReturnTypeRef);
    if ReturnType = nil then
      raise EModelReferenceNotFound.CreateFmt('Return type %s not found for action %s.%s',
        [FReturnTypeRef, Controller.Name, Name]);
    FReturnTypeRef := '';
  end;

  // Prepare Route
  FreeAndNil(FRouteInfo);
  FRouteInfo := TXDataRouteInfo.Create;
  FRouteInfo.Process(Controller.Name + '/' + Self.Name);

  // Bind parameters to existing PathParams
  for I := 0 to FRouteInfo.SegmentCount - 1 do
  begin
    Segment := FRouteInfo.Segments[I];
    if Segment.IsParam then
    begin
      Segment.ParamIndex := -1;
      // find an existing parameter by name
      for ParamDefIndex := 0 to PathParamCount - 1 do
        if SameText(PathParams[ParamDefIndex].Name, Segment.ParamName) then
        begin
          Segment.ParamIndex := ParamDefIndex;
          break;
        end;
      if Segment.ParamIndex = -1 then
        raise EXDataInvalidRouteParam.Create(Self, Segment.Value);
    end;
  end;
end;

function TXDataAction.QueryParamCount: Integer;
begin
  Result := ParamCount(TBindingMode.FromURI);
end;

function TXDataAction.RequiredPathParamCount: Integer;
var
  I: Integer;
begin
  Result := 0;
  for I := 0 to Parameters.Count - 1 do
    if Parameters[I].BindingMode = TBindingMode.FromPath then
      if not Parameters[I].HasDefaultValue then
        Inc(Result);
end;

function TXDataAction.ParamStreamIndex: Integer;
var
  I: Integer;
begin
  for I := 0 to Parameters.Count - 1 do
    if Assigned(Parameters[I].ParamType) and (Parameters[I].ParamType.TypeKind = TXTypeKind.xtRaw) then
    begin
      Result := I;
      Exit;
    end;

  if IsParamStream then
    Result := 0
  else
    Result := -1;
end;

function TXDataAction.GetBodyParam(Index: Integer): TXDataParamDef;
begin
  Result := GetParam(TBindingMode.FromBody, Index);
end;

function TXDataAction.GetController: TXDataController;
begin
  Result := TXDataController(inherited Parent);
end;

function TXDataAction.GetParam(Binding: TBindingMode; Index: Integer): TXDataParamDef;
var
  I, CurIndex: Integer;
begin
  Result := nil;
  CurIndex := -1;
  for I := 0 to Parameters.Count - 1 do
    if Parameters[I].BindingMode = Binding then
    begin
      Inc(CurIndex);
      if Index = CurIndex then
      begin
        Result := Parameters[I];
        Exit;
      end;
    end;
  ErrorOutOfRange;
end;

function TXDataAction.GetPathParam(Index: Integer): TXDataParamDef;
begin
  Result := GetParam(TBindingMode.FromPath, Index);
end;

function TXDataAction.GetQueryParam(Index: Integer): TXDataParamDef;
begin
  Result := GetParam(TBindingMode.FromURI, Index);
end;

function TXDataAction.GetReturnTypeRef: string;
begin
  if FReturnType <> nil then
    Result := FReturnType.Name
  else
    Result := '';
end;

{ TXDataParamDef }

function TXDataParamDef.GetParent: TXDataAction;
begin
  Result := TXDataAction(inherited Parent);
end;

function TXDataParamDef.GetTypeNameRef: string;
begin
  if (FType <> nil) and (GetTypeRef = '') then
    Result := FType.Name
  else
    Result := '';
end;

function TXDataParamDef.GetTypeRef: string;
begin
  // backward compatibility: GetType only returns value if the type is
  // scalar type and not a collection. This is what previous XData clients expect
  if (FType <> nil) and (FType is TXDataScalarType) and not FType.IsCollection then
    Result := FType.Name
  else
    Result := '';
end;

function TXDataParamDef.GetUrlConverter: TXDataTypeConverter;
begin
  if ParamType <> nil then
    Result := ParamType.UrlConverter
  else
    Result := nil;
end;

function TXDataParamDef.Index: Integer;
begin
  Result := Parent.IndexOf(Self);
end;

procedure TXDataParamDef.Prepare;
begin
  // Solve type reference, if any
  if FTypeRef <> '' then
  begin
    ParamType := Parent.Controller.Schema.FindType(FTypeRef);
    if ParamType = nil then
      raise EModelReferenceNotFound.CreateFmt('Param type %s not found for property %s.%s',
        [FTypeRef, Parent.Name, Name]);
    FTypeRef := '';
  end;
  if FTypeNameRef <> '' then
  begin
    ParamType := Parent.Controller.Schema.FindType(FTypeNameRef);
    FTypeNameRef := '';
  end;
end;

procedure TXDataParamDef.SetDefaultValue(const Value: TValue);
begin
  FDefaultValue := Value;
  FHasDefaultValue := True;
end;

{ TXDataController }

constructor TXDataController.Create;
begin
  {$IFDEF GENERICS}
  FActions := TOwnedList<TXDataAction, TXDataController>.Create(Self);
  {$ELSE}
  FActions := TXDataActionList.Create(Self);
  {$ENDIF}
end;

destructor TXDataController.Destroy;
begin
  FActions.Free;
  FRouteInfo.Free;
  inherited;
end;

function TXDataController.GetSchema: TXDataSchema;
begin
  Result := TXDataSchema(inherited Parent);
end;

procedure TXDataController.Prepare;
var
  ActionIndex: Integer;
  Action: TXDataAction;
begin
  // prepare RouteInof
  FreeAndNil(FRouteInfo);
  FRouteInfo := TXDataRouteInfo.Create;
  FRouteInfo.Process(Name);

  // prepare actions
  for ActionIndex := 0 to Actions.Count - 1 do
  begin
    Action := Actions[ActionIndex];
    Action.Prepare;
  end;
end;

{ TXDataNavigationProperty }

function TXDataNavigationProperty.GetParent: TXDataEntityType;
begin
  Result := TXDataEntityType(inherited Parent);
end;

function TXDataNavigationProperty.GetTarget: TXDataStructuredType;
begin
  Result := Target;
end;

function TXDataNavigationProperty.GetTypeKind: TXTypeKind;
begin
  if (Target <> nil) and (Target.IsCollection) then
    Result := TXTypeKind.xtEntityCollection
  else
    Result := TXTypeKind.xtEntity;
end;

procedure TXDataNavigationProperty.Prepare;
begin
  if FTargetRef <> '' then
  begin
    Target := Parent.Schema.FindEntityType(FTargetRef);
    if Target = nil then
      raise EModelReferenceNotFound.CreateFmt('Target %s not found for navigation property %s.%s',
        [FTargetRef, Parent.Name, Name]);
    FTargetRef := '';
  end;
end;

{ TXDataOwnedList }

{$IFNDEF GENERICS}
constructor TXDataOwnedList.Create;
begin
  Create(nil);
end;

constructor TXDataOwnedList.Create(AOwner: TXDataModelObject);
begin
  inherited Create(AOwner <> nil);
  FOwner := AOwner;
end;

{$IFDEF PAS2JS}
procedure TXDataOwnedList.Notify(Ptr: JSValue; Action: TListNotification);
{$ELSE}
procedure TXDataOwnedList.Notify(Ptr: Pointer; Action: TListNotification);
{$ENDIF}
begin
  if FOwner = nil then Exit; // not managed
  
  if Action = lnAdded then
    TXDataModelObject(Ptr).Parent := FOwner
  else
    TXDataModelObject(Ptr).Parent := nil;
  inherited;
end;
{$ENDIF}

{ TXDataParamDefList }

{$IFNDEF GENERICS}
function TXDataParamDefList.GetItem(Index: Integer): TXDataParamDef;
begin
  Result := TXDataParamDef(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataEntityContainerList }

{$IFNDEF GENERICS}
function TXDataEntityContainerList.GetItem(
  Index: Integer): TXDataEntityContainer;
begin
  Result := TXDataEntityContainer(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataSchemaList }

{$IFNDEF GENERICS}
function TXDataSchemaList.GetItem(Index: Integer): TXDataSchema;
begin
  Result := TXDataSchema(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataPropertyList }

{$IFNDEF GENERICS}
function TXDataPropertyList.GetItem(Index: Integer): TXDataProperty;
begin
  Result := TXDataProperty(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataEnumTypeList }

{$IFNDEF GENERICS}
function TXDataEnumTypeList.GetItem(Index: Integer): TXDataEnumType;
begin
  Result := TXDataEnumType(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataEnumMemberList }

{$IFNDEF GENERICS}
function TXDataEnumMemberList.GetItem(Index: Integer): TXDataEnumMember;
begin
  Result := TXDataEnumMember(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataEntityTypeList }

{$IFNDEF GENERICS}
function TXDataEntityTypeList.GetItem(Index: Integer): TXDataEntityType;
begin
  Result := TXDataEntityType(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataInstanceTypeList }

{$IFNDEF GENERICS}
function TXDataInstanceTypeList.GetItem(Index: Integer): TXDataInstanceType;
begin
  Result := TXDataInstanceType(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataControllerList }

{$IFNDEF GENERICS}
function TXDataControllerList.GetItem(Index: Integer): TXDataController;
begin
  Result := TXDataController(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataOwnedActionList }

{$IFNDEF GENERICS}
function TXDataActionList.GetItem(Index: Integer): TXDataAction;
begin
  Result := TXDataAction(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataSimplePropertyList }

{$IFNDEF GENERICS}
function TXDataSimplePropertyList.GetItem(Index: Integer): TXDataSimpleProperty;
begin
  Result := TXDataSimpleProperty(inherited Items[Index]);
end;
{$ENDIF}

{ EXDataEntityTypeNotFound }

constructor EXDataEntityTypeNotFound.Create(const AName: string);
begin
  inherited CreateFmt('Entity type not found for type "%s"', [AName]);
end;

{ EXDataEntitySetNotFound }

constructor EXDataEntitySetNotFound.Create(const AName: string);
begin
  inherited CreateFmt('Entity set "%s" not found', [AName]);
end;

{ ECannotBuildKeyPredicateWrongValueLength }

constructor ECannotBuildKeyPredicateWrongValueLength.Create(
  AType: TXDataEntityType);
begin
  inherited CreateFmt('Cannot create id predicate for type "%s". ' +
    'The length of id value does not match number of elements in composite key', [AType.QualifiedName]);
end;

{ ECannotBuildCanonicalUrl }

constructor ECannotBuildCanonicalUrl.Create(AType: TXDataEntityType);
begin
  inherited CreateFmt('Cannot create canonical url for type "%s"', [AType.QualifiedName]);
end;

{ TXDataEntitySetList }

{$IFNDEF GENERICS}
function TXDataEntitySetList.GetItem(Index: Integer): TXDataEntitySet;
begin
  Result := TXDataEntitySet(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataNavigationPropertyList }

{$IFNDEF GENERICS}
function TXDataNavigationPropertyList.GetItem(
  Index: Integer): TXDataNavigationProperty;
begin
  Result := TXDataNavigationProperty(inherited Items[Index]);
end;
{$ENDIF}

{ EFromURIBindingNotSupported }

constructor EFromURIBindingNotSupported.Create(AParam: TXDataParamDef);
var
  ParamTypeName: string;
begin
  if AParam.ParamType <> nil then
    ParamTypeName := AParam.ParamType.Name
  else
    ParamTypeName := '(undefined)';

  inherited CreateFmt('Cannot define action "%s": Type "%s" for param "%s" cannot be bound from URI',
    [AParam.Parent.Name, ParamTypeName, AParam.Name]);
end;

{ EUrlConverterNotFound }

constructor EUrlConverterNotFound.Create(AType: TXDataType);
var
  ATypeName: string;
begin
  if AType = nil then
    ATypeName := '(null)'
  else
    ATypeName := AType.Name;
  inherited CreateFmt('Could not find URL converter for type "%s"', [ATypeName]);
end;

{ TXDataUrlConverters }

constructor TXDataUrlConverters.Create;
begin
  inherited Create;
  FConverterMap := TStringMap.Create(True);
end;

destructor TXDataUrlConverters.Destroy;
begin
  FConverterMap.Free;
  inherited;
end;

function TXDataUrlConverters.Find(const ATypeName: string): TXDataTypeConverter;
begin
  if FConverterMap.ContainsKey(ATypeName) then
    Result := TXDataTypeConverter(FConverterMap[ATypeName])
  else
    Result := nil;
end;

procedure TXDataUrlConverters.RegisterConverter(const ATypeName: string;
  AConverter: TXDataTypeConverter);
begin
  FConverterMap.AddOrSetValue(ATypeName, AConverter);
end;

{ TXDataRouteInfo }

constructor TXDataRouteInfo.Create;
begin
  FSegments := TXDataRouteSegmentList.Create;
end;

destructor TXDataRouteInfo.Destroy;
begin
  FSegments.Free;
  inherited;
end;

function TXDataRouteInfo.GetSegment(Index: Integer): TXDataRouteSegment;
begin
  Result := FSegments[Index];
end;

function TXDataRouteInfo.GetSegmentCount: Integer;
begin
  Result := FSegments.Count;
end;

{$IFDEF PAS2JS}
function FindDelimiter(const S: string; StartIdx: Integer = 1): Integer;
var
  Stop: Boolean;
  Len: Integer;
begin
  Result := 0;

  Len := Length(S);
  Stop := False;
  while (not Stop) and (StartIdx <= Len) do
    if S[StartIdx] = '/' then
    begin
      Result := StartIdx;
      Stop := True;
    end
    else
      Inc(StartIdx);
end;

function SplitString(const S, Delimiters: string): TStringDynArray;
var
  StartIdx: Integer;
  FoundIdx: Integer;
  SplitPoints: Integer;
  CurrentSplit: Integer;
  i: Integer;
begin
  Result := nil;

  if S <> '' then
  begin
    { Determine the length of the resulting array }
    SplitPoints := 0;
    for i := 1 to Length(S) do
      if S[i] = '/' then
        Inc(SplitPoints);

    SetLength(Result, SplitPoints + 1);

    { Split the string and fill the resulting array }
    StartIdx := 1;
    CurrentSplit := 0;
    repeat
      FoundIdx := FindDelimiter(S, StartIdx);
      if FoundIdx <> 0 then
      begin
        Result[CurrentSplit] := Copy(S, StartIdx, FoundIdx - StartIdx);
        Inc(CurrentSplit);
        StartIdx := FoundIdx + 1;
      end;
    until CurrentSplit = SplitPoints;

    // copy the remaining part in case the string does not end in a delimiter
    Result[SplitPoints] := Copy(S, StartIdx, Length(S) - StartIdx + 1);
  end;
end;
{$ENDIF}

procedure TXDataRouteInfo.Process(const ARoute: string);
var
  I: Integer;
  StrSegments: TStringDynArray;
begin
  // add the segments
  StrSegments := SplitString(ARoute, '/');
  for I := 0 to Length(StrSegments) - 1 do
    if StrSegments[I] <> '' then
      FSegments.Add(TXDataRouteSegment.Create(StrSegments[I]));

  // Define the priority and count the parameters
  // Priority is defined as this: all the exact segments that come first have
  // higher priority. Any segment with parameter is less priority.
  // For example, the following routes are in order of priority (higher to low)
  // a/b/c
  // a/b/?
  // a/?/c
  // ?/b/c
  // ?
  FPriority := 0;
  FParamCount := 0;
  for I := 0 to SegmentCount - 1 do
  begin
    if Segments[I].IsParam then
      Inc(FParamCount)
    else
      FPriority := FPriority or (1 shl (16 - I));
  end;
end;

{ TXDataRouteSegment }

constructor TXDataRouteSegment.Create(const AValue: string);
begin
  FValue := AValue;
//  if Value = '?' then
//    FSegmentType := TXDataRouteSegmentType.Parameter;

  if (Length(Value) >= 3) and (Value[1] = '{') and (Value[Length(Value)] = '}') then
  begin
    FIsParam := True;
    FParamName := Copy(Value, 2, Length(Value) - 2);
  end;
end;

{ EXDataInvalidRouteParam }

constructor EXDataInvalidRouteParam.Create(Action: TXDataAction;
  const ParamName: string);
begin
  inherited CreateFmt('Invalid param "%s" in route of action "%s"',
    [ParamName, Action.OperationId]);
end;

{ TXDataRouteSegmentList }

{$IFNDEF GENERICS}
function TXDataRouteSegmentList.GetItem(Index: Integer): TXDataRouteSegment;
begin
  Result := TXDataRouteSegment(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataInstanceType }

constructor TXDataInstanceType.Create;
begin
  inherited;
  {$IFDEF GENERICS}
  FProperties := TOwnedList<TXDataInstanceSimpleProperty, TXDataInstanceType>.Create(Self);
  FNavigationProperties := TOwnedList<TXDataInstanceNavigationProperty, TXDataInstanceType>.Create(Self);
  {$ELSE}
  FProperties := TXDataInstanceScalarPropertyList.Create(Self);
  FNavigationProperties := TXDataInstanceNavigationPropertyList.Create(Self);
  {$ENDIF}
end;

destructor TXDataInstanceType.Destroy;
begin
  FNavigationProperties.Free;
  FProperties.Free;
  FCollection.Free;
  inherited;
end;

function TXDataInstanceType.GetBaseTypeRef: string;
begin
  if FBaseType <> nil then
    Result := FBaseType.Name
  else
    Result := '';
end;

function TXDataInstanceType.GetCollection: TXDataInstanceCollectionType;
begin
  if FCollection = nil then
  begin
    FCollection := TXDataInstanceCollectionType.Create;
    FCollection.ItemType := Self;
    FCollection.Parent := Self.Parent;
  end;
  Result := FCollection;
end;

function TXDataInstanceType.GetStructuredProperty(Index: Integer): TXDataStructuredProperty;
begin
  Result := NavigationProperties[Index]
end;

function TXDataInstanceType.GetScalarProperty(Index: Integer): TXDataScalarProperty;
begin
  Result := Properties[Index];
end;

function TXDataInstanceType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtInstance;
end;

function TXDataInstanceType.StructuredPropertyCount: Integer;
begin
  Result := NavigationProperties.Count;
end;

procedure TXDataInstanceType.Prepare;
var
  I: Integer;
begin
  if FBaseTypeRef <> '' then
  begin
    BaseType := Schema.FindInstanceType(FBaseTypeRef);
    if BaseType = nil then
      raise EModelReferenceNotFound.CreateFmt('BaseType %s not found for instance type %s', [FBaseTypeRef, Name]);
    FBaseTypeRef := '';
  end;
  if BaseType <> nil then
    BaseType.Prepare;

  for I := 0 to Properties.Count - 1 do
    Properties[I].Prepare;
  for I := 0 to NavigationProperties.Count - 1 do
    NavigationProperties[I].Prepare;
end;

function TXDataInstanceType.ScalarPropertyCount: Integer;
begin
  Result := Properties.Count;
end;

function TXDataInstanceType.QualifiedName: string;
begin
  Result := Self.Name;
  if Self.Schema <> nil then
  begin
    if Self.Schema.Alias <> '' then
      Result := Self.Schema.Alias + '.' + Self.Name
    else
    if Self.Schema.Namespace <> '' then
      Result := Self.Schema.Namespace + '.' + Self.Name;
  end;
end;

{ TXDataInstanceCollectionType }

function TXDataInstanceCollectionType.GetIsCollection: Boolean;
begin
  Result := True;
end;

function TXDataInstanceCollectionType.GetName: string;
begin
  if ItemType <> nil then
    Result := Format('Collection(%s)', [ItemType.Name])
  else
    Result := 'Collection()';
end;

function TXDataInstanceCollectionType.GetTypeKind: TXTypeKind;
begin
  Result := TXTypeKind.xtInstanceCollection;
end;

function TXDataInstanceCollectionType.GetWrappedType: TXDataType;
begin
  Result := ItemType;
end;

function TXDataInstanceCollectionType.QualifiedName: string;
begin
  if ItemType <> nil then
    Result := Format('Collection(%s)', [ItemType.QualifiedName])
  else
    Result := 'Collection()';
end;

{ TXDataStructuredProperty }

function TXDataStructuredProperty.GetTargetRef: string;
begin
  if Target <> nil then
    Result := Target.Name
  else
    Result := FTargetRef;
end;

function TXDataStructuredProperty.GetValueType: TXDataType;
begin
  Result := Target;
end;

function TXDataStructuredProperty.IsSimple: Boolean;
begin
  Result := False;
end;

{ TXDataInstanceNavigationProperty }

function TXDataInstanceNavigationProperty.GetParent: TXDataInstanceType;
begin
  Result := TXDataInstanceType(inherited Parent);
end;

function TXDataInstanceNavigationProperty.GetTarget: TXDataStructuredType;
begin
  Result := Target;
end;

function TXDataInstanceNavigationProperty.GetTypeKind: TXTypeKind;
begin
  if Target = nil then Exit(TXTypeKind.xtUndefined);

  if Target is TXDataEntityType then
  begin
    if Target.IsCollection then
      Result := TXTypeKind.xtEntityCollection
    else
      Result := TXTypeKind.xtEntity;
  end
  else
  begin
    if Target.IsCollection then
      Result := TXTypeKind.xtInstanceCollection
    else
      Result := TXTypeKind.xtInstance;
  end;
end;

procedure TXDataInstanceNavigationProperty.Prepare;
begin
  if FTargetRef <> '' then
  begin
    Target := Parent.Schema.FindEntityType(FTargetRef);
    if Target = nil then
      Target := Parent.Schema.FindInstanceType(FTargetRef);
    FTargetRef := '';
  end;
end;

{ TXDataInstanceSimpleProperty }

function TXDataInstanceSimpleProperty.GetParent: TXDataInstanceType;
begin
  Result := TXDataInstanceType(inherited Parent);
end;

procedure TXDataInstanceSimpleProperty.Prepare;
begin
  // Resolve type reference
  if FTypeRef <> '' then
  begin
    PropertyType := Parent.Schema.FindScalarType(FTypeRef);
    FTypeRef := '';
  end;
end;

{ TXDataInstanceScalarPropertyList }

{$IFNDEF GENERICS}
function TXDataInstanceScalarPropertyList.GetItem(Index: Integer): TXDataInstanceSimpleProperty;
begin
  Result := TXDataInstanceSimpleProperty(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataInstancePropertyList }

{$IFNDEF GENERICS}
function TXDataInstanceNavigationPropertyList.GetItem(Index: Integer): TXDataInstanceNavigationProperty;
begin
  Result := TXDataInstanceNavigationProperty(inherited Items[Index]);
end;
{$ENDIF}

{ TXDataStructuredType }

function TXDataStructuredType.FindAnyProperty(const AName: string): TXDataProperty;
begin
  Result := FindScalarProperty(AName);
  if Result = nil then
    Result := FindStructuredProperty(AName);
end;

function TXDataStructuredType.FindScalarProperty(const AName: string): TXDataScalarProperty;
var
  Prop: TXDataScalarProperty;
  I: Integer;
begin
  for I := 0 to ScalarPropertyCount - 1 do
  begin
    Prop := GetScalarProperty(I);
    if SameText(AName, Prop.Name) then
      Exit(Prop);
  end;
  Result := nil;
end;

function TXDataStructuredType.FindStructuredProperty(const AName: string): TXDataStructuredProperty;
var
  Prop: TXDataStructuredProperty;
  I: Integer;
begin
  for I := 0 to StructuredPropertyCount - 1 do
  begin
    Prop := GetStructuredProperty(I);
    if SameText(AName, Prop.Name) then
      Exit(Prop);
  end;
  Result := nil;
end;

function TXDataStructuredType.GetSchema: TXDataSchema;
begin
  Result := TXDataSchema(inherited Parent);
end;

end.


